import { ServicePricingInputs, DefaultTaxInputs } from './components/ServicePricingInputs';
import React, { useState, useEffect } from 'react';
import { Form } from 'react-final-form';
import { SelectInput, TextInput, required, minValue, maxValue, useUpdate,
  useNotify, Tab, TabbedShowLayout,
  FormWithRedirect, useRefresh, SaveButton, Button, useDataProvider, BooleanInput, ShowButton, PasswordInput , useResourceContext, useGetList, ArrayInput, useCreate,
  SimpleFormIterator, FormDataConsumer, RadioButtonGroupInput, ReferenceInput, NumberInput,
  List as RaList, Datagrid, NumberField, TextField, BooleanField, FunctionField, TopToolbar, ResourceContextProvider, Confirm,
} from 'react-admin';

import Typography from '@material-ui/core/Typography';
import { BoxPhotoUser } from './resources/docs';
import { targets , modules, modulesOptions, contexts } from './common/constants';

import {useHistory, useLocation} from 'react-router-dom';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import {Checkbox, FormControlLabel } from '@mui/material';
import List from '@mui/material/List';
import Tabs from '@mui/material/Tabs';
import MuiTab from '@mui/material/Tab';

import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DraftsIcon from '@mui/icons-material/Drafts';
import SettingsIcon from '@mui/icons-material/Settings';
import DashboardIcon from '@mui/icons-material/Dashboard';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@material-ui/icons/Edit';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import BackupIcon from '@mui/icons-material/Backup';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import ListIcon from '@mui/icons-material/List';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import CachedIcon from '@mui/icons-material/Cached';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import TuneIcon from '@mui/icons-material/Tune';

import { useStyles  } from './common/styles';

import { DocsList  } from './resources/docs';

import Divider from '@mui/material/Divider';


import BusinessIcon from '@mui/icons-material/Business';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import BorderAllIcon from '@mui/icons-material/BorderAll';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import PostAddIcon from '@mui/icons-material/PostAdd';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import MuiTextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';


import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import IconCancel from '@material-ui/icons/Cancel';

import { ColorInput } from 'react-admin-color-input';
import { apiUrl, projectUrl } from './common/constants';
import { headersAPIObjectAuth } from './common/utils';

import MyLoading from './components/MyLoading';
import { fetchCustomFields } from './components/CustomFields';

import Grid from '@mui/material/Grid';

import { PermissionsList  } from './resources/users_permissions';
import { useTranslate, choicesLanguage, defaultLanguage } from './common/language';
import { subscriptionModule  } from './common/utils';

import { validateMaxLength, validateMinMaxLengthAndCharacters, validateEmail  } from './components/Validator';
import { VersionInfo } from './components/VersionInfo';

export const Settings = () => {
  var translate = useTranslate();
  
  const isSuperAdmin = ['SIFAC'].includes(localStorage.getItem('permissions_groups'));
  const isOwner = ['OWNER'].includes(localStorage.getItem('permissions_groups'));
  const isAdmin = ['OWNER', 'ADMIN', 'ADMIN_READER'].includes(localStorage.getItem('permissions_groups'));
  const isAdminOrContacts = ['OWNER', 'ADMIN', 'ADMIN_CONTACTS', 'ADMIN_READER'].includes(localStorage.getItem('permissions_groups'));
  
  return (
    <>
    <Box sx={{ width: '100%', maxWidth: 500, bgcolor: 'background.paper' }} className="settings_box" >
      
      <List>
        { isAdmin ? ( 
          <ListItem>
            <ListItemButton component={Link} to={{ pathname: '/settings-data' }} >
              <ListItemIcon>
                <BusinessIcon />
              </ListItemIcon>
              <ListItemText primary={translate('settings.data')} secondary={translate('settings.data_desc')} />
            </ListItemButton>
          </ListItem>
        ) : <span /> }
        
        { isAdmin ? ( 
          <ListItem>
            <ListItemButton component={Link} to={{ pathname: '/settings-dashboard' }} >
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary={translate('settings.dashboard')} secondary={translate('settings.dashboard_desc')} />
            </ListItemButton>
          </ListItem>
        ) : <span /> }

        { isSuperAdmin ? ( 
          <ListItem>
            <ListItemButton component={Link} to={{ pathname: '/settings-general/fees' }} >
              <ListItemIcon>
                <TuneIcon />
              </ListItemIcon>
              <ListItemText primary={translate('settings.general_configuration')} secondary={translate('settings.general_configuration_desc')}/>
            </ListItemButton>
          </ListItem>
        ) : <span /> }

        { subscriptionModule(modules.REMITTANCES) || subscriptionModule(modules.DONATIONS) || isSuperAdmin ?
          ( isAdminOrContacts ) || isSuperAdmin ? ( 
            <ListItem>
              <ListItemButton component={Link}  to={{ pathname: '/settings-ibans' }} >
                <ListItemIcon>
                  <AccountBalanceIcon />
                </ListItemIcon>
                <ListItemText primary={translate('settings.ibans')} secondary={translate('settings.ibans_desc')}/>
              </ListItemButton>
            </ListItem>
          ): <span /> 
          : null }
          
        { !subscriptionModule(modules.RECERCAT) && isAdmin ? 
            <ListItem>
              <ListItemButton component={Link}  to={{ pathname: '/settings-docs' }} >
                <ListItemIcon>
                  <PermMediaIcon />
                </ListItemIcon>
                <ListItemText primary={translate('settings.docs')} secondary={translate('settings.docs_desc')}/>
              </ListItemButton>
            </ListItem>
          : <span /> 
        }
        
        { subscriptionModule(modules.TICKETS) ?
          ( isAdmin ) ? ( 
            <ListItem>
              <ListItemButton component={Link}  to={{ pathname: '/settings-tickets' }} >
                <ListItemIcon>
                  <ConfirmationNumberIcon />
                </ListItemIcon>
                <ListItemText primary={translate('tickets.title')} secondary={translate('tickets.description')}/>
              </ListItemButton>
            </ListItem>
          ): <span /> 
          : null }
          
        { subscriptionModule(modules.FEDERATION) || subscriptionModule(modules.DONATIONS,modulesOptions.DONATIONS_OWN) ?
          isAdmin ? 
            <ListItem>
              <ListItemButton component={Link}  to={{ pathname: '/settings-donations-own' }} >
                <ListItemIcon>
                  <IntegrationInstructionsIcon />
                </ListItemIcon>
                <ListItemText primary={translate('settings.donations_own')} secondary={translate('settings.donations_own_desc')}/>
              </ListItemButton>
            </ListItem>
          : <span /> 
        : null }
        
        { subscriptionModule(modules.FEDERATION) || subscriptionModule(modules.DONATIONS,modulesOptions.DONATIONS_OWN) || subscriptionModule(modules.REMITTANCES) ?
          isAdmin ? 
            <ListItem>
              <ListItemButton component={Link}  to={{ pathname: '/settings-donations-certificates' }} >
                <ListItemIcon>
                  <VolunteerActivismIcon />
                </ListItemIcon>
                <ListItemText primary={translate('settings.donations_certificates')} secondary={translate('settings.donations_certificates_desc')}/>
              </ListItemButton>
            </ListItem>
          : <span /> 
        : null }        

        { subscriptionModule(modules.DONATIONS) || isSuperAdmin ?
          ( isAdmin || isSuperAdmin ? ( 
            <ListItem>
              <ListItemButton component={Link}  to={{ pathname: '/settings-payment-systems' }} >
                <ListItemIcon>
                  <CreditCardIcon />
                </ListItemIcon>
                <ListItemText primary={translate('settings.payment_systems')} secondary={translate('settings.payment_systems_desc')}/>
              </ListItemButton>
            </ListItem>
          ): <span /> )
          : null }
          
        { subscriptionModule(modules.POSTAL_LABELS) ?
          ( isAdminOrContacts ) ? ( 
            <ListItem>
              <ListItemButton component={Link}  to={{ pathname: '/settings-postal-labels' }} >
                <ListItemIcon>
                  <BorderAllIcon />
                </ListItemIcon>
                <ListItemText primary={translate('settings.postal_labels')} secondary={translate('settings.postal_labels_desc')}/>
              </ListItemButton>
            </ListItem>
          ): <span /> 
          : null }
        
        { subscriptionModule(modules.ALERTS) && isAdmin ?
            <ListItem>
              <ListItemButton component={Link}  to={{ pathname: '/alerts' }} >
                <ListItemIcon>
                  <NotificationsActiveIcon />
                </ListItemIcon>
                <ListItemText primary={translate('settings.alerts')} secondary={translate('settings.alerts_desc')}/>
              </ListItemButton>
            </ListItem>          
          : null }
  
        { isAdminOrContacts ? ( 
          <ListItem>
            <ListItemButton component={Link} to={{ pathname: '/settings-add-member' }} >
              <ListItemIcon>
                <FormatAlignLeftIcon />
              </ListItemIcon>
              { subscriptionModule(modules.RECERCAT) ?
                <ListItemText primary={translate('settings.recercat_add_member')} secondary={translate('settings.recercat_add_member_desc')}/>
                :
                <ListItemText primary={translate('settings.add_member')} secondary={translate('settings.add_member_desc')}/>
              }
            </ListItemButton>
          </ListItem>
        ) : <span /> }
        
        { (subscriptionModule(modules.DIGITAL_CARDS) || subscriptionModule(modules.WALLETS)) && isAdmin ? (
          <ListItem>
            <ListItemButton component={Link} to={{ pathname: '/settings-card-validation' }} >
              <ListItemIcon>
                <FactCheckIcon />
              </ListItemIcon>
              <ListItemText primary={translate('settings.card_validation')} secondary={translate('settings.card_validation_desc')}/>
            </ListItemButton>
          </ListItem>
        ) : <span /> }
      
        { subscriptionModule(modules.CLASSROOMS ) ?
          isAdminOrContacts ? ( 
            <ListItem>
              <ListItemButton component={Link}  to={{ pathname: '/settings-classrooms-requests' }} >
                <ListItemIcon>
                  <MeetingRoomIcon />
                </ListItemIcon>
                <ListItemText primary={translate('settings.classrooms_requests')} secondary={translate('settings.classrooms_requests_desc')}/>
              </ListItemButton>
            </ListItem>
          ) : <span />
          : null }
  
        { subscriptionModule(modules.FEDERATION) ?
          isAdminOrContacts ? ( 
            <ListItem>
              <ListItemButton component={Link}  to={{ pathname: '/settings-annuary-form' }} >
                <ListItemIcon>
                  <FormatAlignLeftIcon />
                </ListItemIcon>
                <ListItemText primary={translate('settings.annuary_form')} secondary={translate('settings.annuary_form_desc')}/>
              </ListItemButton>
            </ListItem>
          ) : <span /> 
        : null }
        
        { subscriptionModule(modules.CUSTOM_FIELDS) && isAdmin ? 
            <ListItem>
              <ListItemButton component={Link}  to={{ pathname: '/custom_fields' }} >
                <ListItemIcon>
                  <PostAddIcon />
                </ListItemIcon>
                <ListItemText primary={translate('custom_fields.main_menu_title')} secondary={translate('custom_fields.main_menu_desc')}/>
              </ListItemButton>
            </ListItem>
          : <span /> 
        }
        
          { isAdmin || isSuperAdmin ?  
              <ListItem>
                <ListItemButton component={Link}  to={{ pathname: '/settings-senders' }} >
                <ListItemIcon>
                  <AlternateEmailIcon />
                </ListItemIcon>
                <ListItemText primary={translate('senders.title')} secondary={translate('senders.desc')}/>
              </ListItemButton>
            </ListItem>
        : null }

        { isSuperAdmin ?
          <ListItem>
            <ListItemButton component={Link} to={{ pathname: '/settings-smtp' }} >
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary={translate('senders.smtp_settings_title')} secondary={translate('senders.smtp_settings_desc')}/>
            </ListItemButton>
          </ListItem>
        : null }
        
        { isAdmin || isSuperAdmin ?
        <ListItem>
          <ListItemButton component={Link} to={{ pathname: '/settings-emails' }} >
            <ListItemIcon>
              <DraftsIcon />
            </ListItemIcon>
            <ListItemText primary={translate('settings.emails')} secondary={translate('settings.emails_desc')}/>
          </ListItemButton>
        </ListItem> : <span /> }
        
        { isAdmin || isSuperAdmin ?
        <ListItem>
          <ListItemButton component={Link} to={{ pathname: '/settings-massive-actions' }} >
            <ListItemIcon>
              <PendingActionsIcon />
            </ListItemIcon>
            <ListItemText primary={translate('settings.massive_actions')} secondary={translate('settings.massive_actions_desc')}/>
          </ListItemButton>
        </ListItem> : <span /> }
        
        { isSuperAdmin || (subscriptionModule(modules.RECERCAT) && (localStorage.getItem('email') === 'admin@softovi.com' || localStorage.getItem('email') === 'francesctomas@gmail.com')) ||
        !subscriptionModule(modules.RECERCAT) && (isAdminOrContacts) ? ( 
        <ListItem>
          <ListItemButton component={Link} to={{ pathname: '/emails' }} >
            <ListItemIcon>            
              <ListIcon />
            </ListItemIcon>
            <ListItemText primary={translate('settings.emails_logs')} secondary={translate('settings.emails_logs_desc')}/>
          </ListItemButton>
        </ListItem>
        ) : <span />  }
          
        { isSuperAdmin ? ( 
          <ListItem>
            <ListItemButton component={Link} to={{ pathname: '/redis' }} >
              <ListItemIcon>
                <CachedIcon />
              </ListItemIcon>
              <ListItemText primary={translate('settings.cache_management')} secondary={translate('settings.cache_management_desc')}/>
            </ListItemButton>
          </ListItem>
        ) : <span /> }

        { isSuperAdmin ? ( 
          <ListItem>
            <ListItemButton component={Link} to={{ pathname: '/settings-sadmin' }} >
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary={translate('settings.maintenance')} secondary={translate('settings.maintenance_desc')}/>
            </ListItemButton>
          </ListItem>
        ) : <span /> }
                      
        { /* DE MOMENT NOMÉS ACTIVEM LA GESTIÓ DE PERMISOS PER AGRUP. CULTURAL BAGES */ }              
        { isOwner && ( window.location.hostname == 'admin.gestioentitats.cat' && localStorage.getItem('associations_id')==75 ) ? ( 
          <ListItem>
            <ListItemButton component={Link} to={{ pathname: '/settings-users' }} >
              <ListItemIcon>
                <SupervisorAccountIcon />
              </ListItemIcon>
              <ListItemText primary={translate('settings.users')} secondary={translate('settings.users_desc')}/>
            </ListItemButton>
          </ListItem>
        ) : <span /> }              
          
      </List>
        
    </Box>
    
    <VersionInfo />
    
    </>
  );
  
};

/*
 * { isAdmin ? ( 
          <ListItem>
            <ListItemButton component={Link} to={{ pathname: '/settings-subscription' }} >
              <ListItemIcon>
                <CardMembershipIcon />
              </ListItemIcon>
              <ListItemText primary={translate('settings.subscription')} secondary={translate('settings.subscription_desc')}/>
            </ListItemButton>
          </ListItem>
          ) : <span /> }      

 */
const updateAssociationInfo = () => {

  const request = new Request(apiUrl + '/associations/info/' + localStorage.getItem('associations_id') , {
    method: 'GET',
    headers: headersAPIObjectAuth()             
  });

  return fetch(request)
    .then(response => response.json())
    .then(data => {      
      localStorage.setItem('associations_name', data.name );
      localStorage.setItem('associations_logo_doc', data.associations_logo_doc );
      localStorage.setItem('friendly_url', data.friendly_url );
      window.location.reload(false);
    })
    .catch(() => {
    });
                        
};

export const SettingsData = () => {
  const translate = useTranslate();
  const history = useHistory();
  const location = useLocation();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [update] = useUpdate();
  const [info, setInfo] = useState();
  const [model182AutonomousDeductions, setModel182AutonomousDeductions] = useState([]);
  const [selectedModel182AutonomousDeductions, setSelectedModel182AutonomousDeductions] = useState([]);
  const associationId = localStorage.getItem('associations_id');

  useEffect(() => {
    if (associationId > 0) {
      dataProvider.getOne('associations', { id: associationId })
        .then(({ data }) => setInfo(data))
        .catch(error => notify(error.message, 'error'));
      fetch(apiUrl + '/donations_model_182_autonomous_deductions/association/' + associationId, {
        headers: headersAPIObjectAuth()
      })
        .then(response => {
          if (!response.ok) throw new Error(translate('settings.model_182_autonomous_deductions_load_error'));
          return response.json();
        })
        .then(data => {
          setModel182AutonomousDeductions(data);
          setSelectedModel182AutonomousDeductions(data.filter(item => item.selected).map(item => item.id));
        })
        .catch(error => notify(error.message, 'error'));
    }
  }, [associationId, dataProvider, notify, translate]);

  useEffect(() => {
    if (info && location.hash === '#model-182-fiscality') {
      window.requestAnimationFrame(() => {
        document.getElementById('model-182-fiscality')?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    }
  }, [info, location.hash]);

  if (!info) return null;

  const handleSubmit = values => {
    const data = {};
    ['name', 'email', 'nif', 'address', 'zip', 'city', 'region', 'country',
      'phone', 'friendly_url', 'lang', 'about_us', 'website', 'opening_hours',
      'longitude', 'latitude', 'donations_model_182_nature',
      'donations_model_182_contact_name', 'donations_model_182_contact_phone']
      .forEach(field => { data[field] = values[field]; });
    data.donations_model_182_nature = values.donations_model_182_nature || null;
    const receiptNumber = (values.donations_model_182_receipt_number || '').trim();
    data.donations_model_182_next_receipt_number = receiptNumber
      ? parseInt(receiptNumber.substring(3), 10) : null;
    data.donations_model_182_contact_name = values.donations_model_182_contact_name || null;
    data.donations_model_182_contact_phone = values.donations_model_182_contact_phone || null;
    ['about_us', 'website', 'opening_hours'].forEach(field => {
      data[field] = values[field] || '';
    });
    ['longitude', 'latitude'].forEach(field => {
      data[field] = values[field] === '' || values[field] == null ? null : values[field];
    });
    update({
      type: 'update', resource: 'associations', payload: { id: associationId, data }
    }, {
      onSuccess: () => {
        fetch(apiUrl + '/donations_model_182_autonomous_deductions/association/' + associationId, {
          method: 'PUT',
          headers: headersAPIObjectAuth(),
          body: JSON.stringify(selectedModel182AutonomousDeductions)
        })
          .then(response => {
            if (!response.ok) throw new Error(translate('settings.model_182_autonomous_deductions_save_error'));
            updateAssociationInfo();
            history.push('/settings');
          })
          .catch(error => notify(error.message, 'error'));
      },
      onFailure: error => notify(error.message, 'error'),
    });
  };

  const maxLength = length => validateMaxLength(length, translate('common.validation.maxLength'));
  const validateOptionalReceiptNumber = value => value && !/^182(?!0{10}$)\d{10}$/.test(value)
    ? translate('settings.model_182_receipt_number_invalid') : undefined;
  const validateOptionalContactPhone = value => value && !/^\d{9}$/.test(value)
    ? translate('settings.model_182_contact_phone_invalid') : undefined;
  const defaultReceiptNumber = info.donations_model_182_next_receipt_number
    ? `182${String(info.donations_model_182_next_receipt_number).padStart(10, '0')}` : '';
  return (
    <FormWithRedirect resource="associations" save={handleSubmit}
      initialValues={{ ...info, id: associationId,
        donations_model_182_nature: info.donations_model_182_nature || 0,
        donations_model_182_receipt_number: defaultReceiptNumber }}
      render={formProps => (
        <>
          <br />
          <Typography variant="h5" className="grey8" align="center">{translate('settings.data')}</Typography>
          <Box sx={{ width: '100%', maxWidth: 900, bgcolor: 'background.paper', padding: '25px' }} className="settings_box">
            <Grid container spacing={3}>
              <Grid item xs={12} sm={7}>
            <Box mb={3}>
              <Typography variant="h6" className="grey8 titleUserShow">{translate('settings.entity_general_data')}</Typography>
              <Divider sx={{ mb: 2 }} />
              <Grid container spacing={2}>
                <Grid item xs={12} sm={8}>
                  <TextInput fullWidth source="name" label={translate('common.name')} validate={[required(), maxLength(100)]} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextInput fullWidth source="nif" label={translate('users.nif')} validate={[maxLength(10)]} />
                </Grid>
                <Grid item xs={12}>
                  <TextInput fullWidth source="friendly_url" label={translate('associations.friendly_url')} validate={[required(), maxLength(255)]} />
                </Grid>
                <Grid item xs={12}>
                  <SelectInput fullWidth source="lang" label={translate('common.language_association')}
                    choices={choicesLanguage(translate, !subscriptionModule(modules.RECERCAT) && (window.location.hostname === 'localhost' || window.location.hostname === 'admin.gestioentitats.cat'))}
                    validate={[required()]} />
                </Grid>
              </Grid>
            </Box>
              </Grid>
              <Grid item xs={12} sm={5}>
            <Box mb={3}>
              <Typography variant="h6" className="grey8 titleUserShow">{translate('settings.entity_logo')}</Typography>
              <Divider sx={{ mb: 2 }} />
              <Box mt={1} sx={{ maxWidth: 280 }}>
                <BoxPhotoUser target={targets.ASSOCIATION} items_id={associationId} edit={true} default_img={1} className="docs_photo_user" />
              </Box>
            </Box>
              </Grid>
            </Grid>
            <Box mb={3}>
              <Typography variant="h6" className="grey8 titleUserShow">{translate('settings.entity_contact')}</Typography>
              <Divider sx={{ mb: 2 }} />
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextInput fullWidth source="email" label={translate('users.email')} validate={[maxLength(100), validateEmail()]} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextInput fullWidth source="phone" label={translate('users.phone')} validate={[maxLength(50)]} />
                </Grid>
                <Grid item xs={12}>
                  <TextInput fullWidth source="website" label={translate('settings.entity_website')} />
                </Grid>
              </Grid>
            </Box>
            <Box mb={3}>
              <Typography variant="h6" className="grey8 titleUserShow">{translate('settings.entity_location')}</Typography>
              <Divider sx={{ mb: 2 }} />
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextInput fullWidth source="address" label={translate('users.address')} validate={[maxLength(255)]} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextInput fullWidth source="zip" label={translate('users.zip')} validate={[maxLength(5)]} />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextInput fullWidth source="city" label={translate('users.city')} validate={[maxLength(100)]} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextInput fullWidth source="region" label={translate('users.region')} validate={[maxLength(100)]} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextInput fullWidth source="country" label={translate('users.country')} validate={[maxLength(255)]} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <NumberInput fullWidth source="longitude" label={translate('settings.entity_longitude')} step="any" validate={[minValue(-180), maxValue(180)]} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <NumberInput fullWidth source="latitude" label={translate('settings.entity_latitude')} step="any" validate={[minValue(-90), maxValue(90)]} />
                </Grid>
              </Grid>
            </Box>
            <Box mb={3}>
              <Typography variant="h6" className="grey8 titleUserShow">{translate('settings.entity_more_information')}</Typography>
              <Divider sx={{ mb: 2 }} />
              <TextInput fullWidth multiline minRows={4} source="about_us" label={translate('settings.entity_about_us')} />
              <TextInput fullWidth multiline minRows={3} source="opening_hours" label={translate('settings.entity_opening_hours')} />
            </Box>
            <Box id="model-182-fiscality" mb={3}>
              <Typography variant="h6" className="grey8 titleUserShow">{translate('settings.entity_fiscality')}</Typography>
              <Divider sx={{ mb: 2 }} />
              <Typography variant="body2" sx={{ mb: 2 }}>{translate('settings.entity_fiscality_help')}</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <SelectInput fullWidth source="donations_model_182_nature"
                    label={translate('settings.model_182_nature')}
                    choices={[
                      { id: 0, name: translate('settings.model_182_nature_none') },
                      { id: 1, name: translate('settings.model_182_nature_1') },
                      { id: 2, name: translate('settings.model_182_nature_2') },
                      { id: 3, name: translate('settings.model_182_nature_3') },
                      { id: 4, name: translate('settings.model_182_nature_4') },
                    ]} />
                </Grid>
                <FormDataConsumer>
                  {({ formData }) => Number(formData.donations_model_182_nature) > 0 ? <>
                    <Grid item xs={12}>
                      <Typography variant="body2">
                        {translate('settings.model_182_optional_defaults_help')}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextInput fullWidth source="donations_model_182_receipt_number"
                        label={translate('settings.model_182_receipt_number')}
                        validate={[validateOptionalReceiptNumber]} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextInput fullWidth source="donations_model_182_contact_phone"
                        label={translate('settings.model_182_contact_phone')}
                        validate={[validateOptionalContactPhone]} />
                    </Grid>
                    <Grid item xs={12}>
                      <TextInput fullWidth source="donations_model_182_contact_name"
                        label={translate('settings.model_182_contact_name')}
                        validate={[maxLength(40)]} />
                    </Grid>
                    {Number(formData.donations_model_182_nature) === 3 ?
                    <Grid item xs={12}>
                      <Typography variant="body2" color="error">{translate('settings.model_182_unsupported_nature')}</Typography>
                    </Grid> : null}
                    {[1, 2].includes(Number(formData.donations_model_182_nature))
                      && model182AutonomousDeductions.length > 0 ? <Grid item xs={12}>
                      <Typography variant="subtitle1" sx={{ mt: 1 }}>
                        {translate('settings.model_182_autonomous_deductions')}
                      </Typography>
                      <Typography variant="body2" sx={{ mb: 1 }}>
                        {translate('settings.model_182_autonomous_deductions_help')}
                      </Typography>
                      {model182AutonomousDeductions.map(item => {
                        const selected = selectedModel182AutonomousDeductions.includes(item.id);
                        return <FormControlLabel key={item.id}
                          control={<Checkbox
                            checked={selected}
                            disabled={!item.active && !selected}
                            onChange={event => setSelectedModel182AutonomousDeductions(previous =>
                              event.target.checked
                                ? [...previous, item.id]
                                : previous.filter(id => id !== item.id))} />}
                          label={`${item.year} · ${item.name} (${item.percentage}%)`} />;
                      })}
                    </Grid> : null}
                  </> : null}
                </FormDataConsumer>
              </Grid>
            </Box>
            <SaveButton saving={formProps.saving} handleSubmitWithRedirect={formProps.handleSubmitWithRedirect} />
          </Box>
        </>
      )}
    />
  );
};
export const SettingsDashboard = () => {
    
  var translate = useTranslate();
  const history = useHistory();
  const dataProvider = useDataProvider();
  const [info, setInfo] = useState();
    
  const notify = useNotify();
  const [update] = useUpdate();
    
  useEffect(() => {
    if (localStorage.getItem('associations_id') > 0)
    {
      dataProvider.getOne('associations', { id: localStorage.getItem('associations_id') })
        .then(({ data }) => {    
          setInfo(data);
        })
        .catch(error => {                                
        });
    }
  }, []);

  if (!info) return null;
    
  const handleSubmit = async values => {
    update(
      { 
        type: 'update', 
        resource: 'associations/dashboard', 
        payload : { id: values.id, data : { 
          dashboard_members_group_id : values.dashboard_members_group_id
        } }
      },
      {
        onSuccess: ({ data }) => {
          history.push('/settings');
        },
        onFailure: ( error ) => {
          notify(error.message, 'error');
        }
      }
    );
  };    
    
  return (
        
    <FormWithRedirect
      resource="associations"        
      save={handleSubmit}
      initialValues={{ id : localStorage.getItem('associations_id'), 
        dashboard_members_group_id : info.dashboard_members_group_id
      }}
      render={formProps => (
        <>
          <br/>
          <Typography variant="h5" className="grey8" align="center">
            {translate('settings.dashboard')}              
          </Typography>
          <Box sx={{ width: '100%', maxWidth: 600, bgcolor: 'background.paper', padding: '25px' }} className="settings_box" >
                    
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <ReferenceInput
                  fullWidth
                  source="dashboard_members_group_id"
                  reference="groups"
                  label={translate('settings.dashboard_members_group')}
                  filter={{ associations_id : localStorage.getItem('associations_id') }}
                  perPage={1000}
                  sort={{ field: 'priority', order: 'ASC' }}
                  validate={[required()]}
                >
                  <SelectInput optionText="name" fullWidth />
                </ReferenceInput>
              </Grid>
            </Grid>

            <SaveButton
              saving={formProps.saving}
              handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
            />

          </Box>
        </>
            
      )}
    />
    
  );
  
};

export const SettingsCardValidation = () => {
    
  var translate = useTranslate();
  const history = useHistory();
  const dataProvider = useDataProvider();
  const [info, setInfo] = useState();
    
  const notify = useNotify();
  const [update] = useUpdate();
  const hasCardsModule = subscriptionModule(modules.DIGITAL_CARDS) || subscriptionModule(modules.WALLETS);
    
  useEffect(() => {
    if (localStorage.getItem('associations_id') > 0)
    {
      dataProvider.getOne('associations', { id: localStorage.getItem('associations_id') })
        .then(({ data }) => {    
          setInfo(data);
        })
        .catch(error => {                                
        });
    }
  }, []);

  if (!hasCardsModule) return <SettingsNotAvailable />;
  if (!info) return null;
  
  const isFacMemberEntity = subscriptionModule(modules.MEMBER_FAC) && info.public_id !== 'FAC';
    
  const handleSubmit = async values => {
    update(
      { 
        type: 'update', 
        resource: 'associations/card-validation', 
        payload : { id: values.id, data : { 
          card_validation_show_name : values.card_validation_show_name,
          card_validation_show_nif : values.card_validation_show_nif,
          card_validation_show_birthday : values.card_validation_show_birthday,
          card_validation_show_num_member : values.card_validation_show_num_member,
          card_validation_show_minor : values.card_validation_show_minor,
          card_validation_show_association_name : values.card_validation_show_association_name,
          card_validation_show_group_name : values.card_validation_show_group_name,
          card_validation_show_date_join : values.card_validation_show_date_join,
          card_validation_show_date_left : values.card_validation_show_date_left,
          card_validation_background_color : values.card_validation_background_color
        } }
      },
      {
        onSuccess: ({ data }) => {
          history.push('/settings');
        },
        onFailure: ( error ) => {
          notify(error.message, 'error');
        }
      }
    );
  };    
    
  return (
        
    <FormWithRedirect
      resource="associations"        
      save={handleSubmit}
      initialValues={{ id : localStorage.getItem('associations_id'), 
        card_validation_show_name : info.card_validation_show_name !== false,
        card_validation_show_nif : info.card_validation_show_nif,
        card_validation_show_birthday : info.card_validation_show_birthday,
        card_validation_show_num_member : info.card_validation_show_num_member !== false,
        card_validation_show_minor : info.card_validation_show_minor,
        card_validation_show_association_name : info.card_validation_show_association_name !== false,
        card_validation_show_group_name : info.card_validation_show_group_name !== false,
        card_validation_show_date_join : info.card_validation_show_date_join,
        card_validation_show_date_left : info.card_validation_show_date_left,
        card_validation_background_color : info.card_validation_background_color || '#efefef'
      }}
      render={formProps => (
        <>
          <br/>
          <Typography variant="h5" className="grey8" align="center">
            {translate('settings.card_validation')}              
          </Typography>
          <Box sx={{ width: '100%', maxWidth: 800, bgcolor: 'background.paper', padding: '25px' }} className="settings_box" >
            
            <Typography variant="h6" className="grey8 titleUserShow">                        
              {translate('settings.card_validation_style')}
            </Typography>
            <Divider className="" />
            <br/>
            
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <ColorInput fullWidth source="card_validation_background_color" label={translate('settings.card_validation_background_color')} validate={[validateMaxLength(7,translate('common.validation.maxLength'))]} />
              </Grid>
            </Grid>
            
            <br/>
            
            <Typography variant="h6" className="grey8 titleUserShow">                        
              {translate('settings.card_validation_logos')}
            </Typography>
            <Divider className="" />
            <br/>
            
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}> 
                <Typography variant="h6" className="grey8" align="" sx={{ mb: 2 }}>
                  {translate('settings.card_validation_top_logo')}              
                </Typography>
                <BoxPhotoUser target={targets.CARD_VALIDATION_TOP_LOGO} items_id={localStorage.getItem('associations_id')} edit={true} default_img={1} className="docs_photo_user" />
              </Grid>
              {!isFacMemberEntity ?
                <Grid item xs={12} sm={6}> 
                  <Typography variant="h6" className="grey8" align="" sx={{ mb: 2 }}>
                    {translate('settings.card_validation_bottom_logo')}              
                  </Typography>
                  <BoxPhotoUser target={targets.CARD_VALIDATION_BOTTOM_LOGO} items_id={localStorage.getItem('associations_id')} edit={true} default_img={1} className="docs_photo_user" />
                </Grid>
              : null}
            </Grid>
            
            <br/>
            <Typography variant="h6" className="grey8 titleUserShow">                        
              {translate('settings.card_validation_fields')}
            </Typography>
            <Divider className="" />
            <br/>
            
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <BooleanInput fullWidth source="card_validation_show_name" label={translate('settings.card_validation_show_name')} />
              </Grid>
              <Grid item xs={12}>
                <BooleanInput fullWidth source="card_validation_show_nif" label={translate('settings.card_validation_show_nif')} />
              </Grid>
              <Grid item xs={12}>
                <BooleanInput fullWidth source="card_validation_show_birthday" label={translate('settings.card_validation_show_birthday')} />
              </Grid>
              <Grid item xs={12}>
                <BooleanInput fullWidth source="card_validation_show_num_member" label={translate('settings.card_validation_show_num_member')} />
              </Grid>
              <Grid item xs={12}>
                <BooleanInput fullWidth source="card_validation_show_minor" label={translate('settings.card_validation_show_minor')} />
              </Grid>
              <Grid item xs={12}>
                <BooleanInput fullWidth source="card_validation_show_association_name" label={translate('settings.card_validation_show_association_name')} />
              </Grid>
              <Grid item xs={12}>
                <BooleanInput fullWidth source="card_validation_show_group_name" label={translate('settings.card_validation_show_group_name')} />
              </Grid>
              <Grid item xs={12}>
                <BooleanInput fullWidth source="card_validation_show_date_join" label={translate('settings.card_validation_show_date_join')} />
              </Grid>
              <Grid item xs={12}>
                <BooleanInput fullWidth source="card_validation_show_date_left" label={translate('settings.card_validation_show_date_left')} />
              </Grid>
            </Grid>

            <SaveButton
              saving={formProps.saving}
              handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
            />

          </Box>
        </>
            
      )}
    />
    
  );
  
};

export const SettingsProfile = ( props ) => {
    
  var translate = useTranslate();
  const history = useHistory();
  const dataProvider = useDataProvider();
  const [info, setInfo] = useState();
  const classes = useStyles();
    
  const [showDialog, setShowDialog] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();  
  const [update, { loading, error }] = useUpdate();
  
  const [language, setLanguage] = useState('0');
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  
   useEffect(() => {
    const storedLanguage = localStorage.getItem('language');
    if (storedLanguage) {
      setLanguage(storedLanguage);
    }
  }, []);
        
  const handleSubmit = async values => {
                
    update(
      { 
        type: 'update',
        resource: 'users_login',
        payload: {
        id: localStorage.getItem('users_login_id'),
        data: {
        password: values.password,
        password_confirmation: values.password_confirmation,
        change_password: showPasswordFields,
        language: values.language, 
        },
        },
       },
      {
        onSuccess: ({ data }) => {
          localStorage.setItem('language', values.language); 
          notify(translate('settings.profile_changed'), 'success');
          history.push('/dashboard');
          window.location.reload(false);
        },
        onFailure: ( error ) => {
          notify(error.message, 'error');
        }
      }
    );
  };    
    
 return (
    <FormWithRedirect
      resource="users_login"           
      save={handleSubmit}
      initialValues={{             
        email: localStorage.getItem('email'),
        password: '',
        password_confirmation: '',
        language: localStorage.getItem('language'),
      }}
      render={formProps => (
        <>
          <br/>
          <Typography variant="h5" className="grey8" align="center">
            {translate('settings.profile')}              
          </Typography>
          <Box sx={{ width: '100%', maxWidth: 600, bgcolor: 'background.paper', padding: '25px' }} className="settings_box">
            <TabbedShowLayout syncWithLocation={false}>
              <Tab
                label={translate('settings.profile_user_tab')}
                contentClassName={classes.tab}
                fullWidth
                path=""
              >
                <br/>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <TextInput 
                      fullWidth 
                      source="email" 
                      label={translate('users.email')} 
                      validate={[validateMaxLength(100, translate('common.validation.maxLength')), validateEmail()]} 
                      disabled 
                      style={{ textAlign: 'left' }} 
                    />
                  </Grid>
                  
                  <Grid item xs={12} sx={{ marginY: 2 }}>
                    <SelectInput
                      source="language"
                      label={translate('common.language')}
                      choices={choicesLanguage(translate, !subscriptionModule(modules.RECERCAT) && (window.location.hostname === 'localhost' || window.location.hostname === 'admin.gestioentitats.cat') )}
                      value={language}
                      validate={[required()]}
                      onChange={(e) => setLanguage(e.target.value)}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12} sx={{ marginY: -1 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          source="change_password"
                          checked={showPasswordFields}
                          onChange={(e) => setShowPasswordFields(e.target.checked)}
                        />
                      }
                       label={translate('settings.change_password')} 
                    />
                  </Grid>

                  {showPasswordFields && (
                    <>
                      <Grid item xs={12}>
                        <PasswordInput 
                          fullWidth 
                          source="password" 
                          label={translate('settings.profile_password')} 
                          validate={[validateMinMaxLengthAndCharacters(translate('common.validation.minMaxLengthAndCharacters'))]} 
                          style={{ textAlign: 'right' }}
                        />                            
                      </Grid>
                      <Grid item xs={12}>
                        <PasswordInput 
                          fullWidth 
                          source="password_confirmation" 
                          label={translate('settings.profile_password_confirmation')} 
                          validate={[validateMinMaxLengthAndCharacters(translate('common.validation.minMaxLengthAndCharacters'))]} 
                          style={{ textAlign: 'right' }}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              </Tab>
            </TabbedShowLayout>
            <br/><br/>

            <SaveButton
              saving={formProps.saving}
              handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
            />
          </Box>    
        </>
      )}
    />
  );
};

const normalizeFields = (jsonString) => {
  try {
    return JSON.parse(jsonString || "[]").map((f, idx) => ({
      id: f.id || `tmp-${idx}`,
      ...f,
      required: f.required === "1",
      actived: f.actived === "1",
    }));
  } catch {
    return [];
  }
};

export const SettingsAddMember = ( props ) => {
    
  var translate = useTranslate();
  const history = useHistory();
  const dataProvider = useDataProvider();
  const [info, setInfo] = useState();
    
  const [showDialog, setShowDialog] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();  
  const [update, { loading, error }] = useUpdate();
  
  let listUrl = '/groups-tree/' + localStorage.getItem('members_pending_group_id');
    
  
    
  useEffect(() => {
    if (localStorage.getItem('associations_id') > 0)
    {
      dataProvider.getOne('associations', { id: localStorage.getItem('associations_id') })
        .then(({ data }) => {    
          setInfo(data);
        })
        .catch(error => {                                
        });
    }
  }, []);
  
  if (!info) return null;
  
  let formUrl = '/public/add-member/' + info.friendly_url;
  if (subscriptionModule(modules.RECERCAT))
  {
    formUrl = '/public/sol-licitud-carnet-recercat?associations_id=' + localStorage.getItem('associations_id');
  }
    
  let formCompleteUrl = projectUrl + '/#' + formUrl;
  
    
  const handleSubmit = async (values) => {
  update(
    { 
      type: 'update', 
      resource: 'associations/add-member', 
      payload : { 
        id: values.id, 
        data : { 
          add_member_actived : values.add_member_actived,
          add_member_logo : values.add_member_logo,
          add_member_bank_data : values.add_member_bank_data,
          add_member_notification : values.add_member_notification,
          add_member_notification_destination : values.add_member_notification_destination,
          add_member_notification_email : values.add_member_notification_email,
          add_member_lopd : values.add_member_lopd,
          add_member_form_sent : values.add_member_form_sent,
          add_member_form_text : values.add_member_form_text,
          add_member_title : values.add_member_title,
          add_member_fields: JSON.stringify(
            (values.add_member_fields || []).map(f => ({
              ...f,
              required: f.required ? "1" : "0",
              actived: f.actived ? "1" : "0",
            }))
          ),
          add_member_validate_email : values.add_member_validate_email,
          add_member_confirmation : values.add_member_confirmation,
          add_member_header_color : values.add_member_header_color,
          add_member_header : values.add_member_header
        } 
      } 
    },
    {
      onSuccess: ({ data }) => {
        history.push('/settings');
      },
      onFailure: (error) => {
        notify(error.message, 'error');
      }
    }
  );
};
    
  const handleClick = (e) => {
    e.preventDefault();
    setShowDialog(true);
  };
  const handleCloseClick = () => {
    setShowDialog(false);
  };
    
  return (
        
    <FormWithRedirect
      resource="associations"        
      save={handleSubmit}
      initialValues={{ id : localStorage.getItem('associations_id'), 
        add_member_actived : info.add_member_actived,
        add_member_logo : info.add_member_logo,
        add_member_bank_data : info.add_member_bank_data,
        add_member_notification : info.add_member_notification,
        add_member_notification_destination : info.add_member_notification_destination || 0,
        add_member_notification_email : info.add_member_notification_email || '',
        add_member_lopd : info.add_member_lopd,
        add_member_form_sent : info.add_member_form_sent,
        add_member_form_text : info.add_member_form_text,
        add_member_title : info.add_member_title,
        add_member_fields: normalizeFields(info.add_member_fields),
        add_member_validate_email : info.add_member_validate_email,
        add_member_confirmation : info.add_member_confirmation,
        add_member_header_color : info.add_member_header_color,
        add_member_header : info.add_member_header
      }}
      render={formProps => (
            
        <>
          <br/>
          <Typography variant="h5" className="grey8" align="center">
            { subscriptionModule(modules.RECERCAT) ? translate('settings.recercat_add_member') : translate('settings.add_member')}              
          </Typography> 
          
          <Box sx={{ width: '100%', maxWidth: 800, bgcolor: 'background.paper', padding: '25px' }} className="settings_box" >            
            <Grid container spacing={1}>
                <Grid item xs={4}>
                    <ShowButton 
                      component={Link}
                      to={formUrl}
                      label={translate('settings.add_member_view_form')}
                      target="_blank"
                      align="right"
                      className
                      icon={null}
                    />
                </Grid>
                { !subscriptionModule(modules.RECERCAT) && localStorage.getItem('members_pending_group_id') !== null && parseInt(localStorage.getItem('members_pending_group_id')) > 0 && (
                <Grid item xs={4}>
                    <ShowButton 
                      component={Link}
                      to={listUrl} 
                      label={translate('settings.add_member_pending_list')}
                      align=""
                      className
                      icon={null}
                    />
                    </Grid>
                )}
        
                <Grid item xs={4}>
                    <a onClick={handleClick} href="">    
                        {translate('settings.add_member_help')}
                    </a>
                </Grid>
                
                <Dialog
              fullWidth
              open={showDialog}
              onClose={handleCloseClick}
              aria-label={translate('remittances.status_form')}
            >
              <DialogTitle>
                {translate('settings.add_member_help')}
                <IconButton
                  aria-label="close"
                  onClick={handleCloseClick}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
                
              <DialogContent>
                { subscriptionModule(modules.RECERCAT) ? translate('settings.recercat_add_member_help_1') : translate('settings.add_member_help_1') }
                <br/>
                <br/>
                <br/><i>
                    &lt;iframe 
                        style="width: 100%; height: 100%; border: none; margin: 0; padding: 0; overflow: scroll-y;" 
                        src="{formCompleteUrl}" /&gt;                        
                </i><br/><br/><br/>
              </DialogContent>

            </Dialog>
            
            </Grid>
          </Box>
            
          <Box sx={{ width: '100%', maxWidth: 800, bgcolor: 'background.paper', padding: '25px' }} className="settings_box" >
            
            <Grid container spacing={1}>
              <Grid item xs={12}>
                { subscriptionModule(modules.RECERCAT) ?
                  <BooleanInput label={translate('settings.recercat_add_member_actived')} fullWidth source="add_member_actived"  />
                  :
                  <BooleanInput label={translate('settings.add_member_actived')} fullWidth source="add_member_actived"  />
                }
              </Grid>
            </Grid>      
            
            { !subscriptionModule(modules.RECERCAT) ?
            <>
            <Typography variant="h6" className="grey8 titleUserShow">                        
              {translate('settings.add_member_header_show')}
            </Typography>
            <Divider className="" />      

            <Grid container spacing={1}>
            <Grid item xs={8}> 
                <RadioButtonGroupInput label="" row={false} source="add_member_header" choices={[
                  { id: 0, name: translate('settings.add_member_header_show_0') },
                  { id: 1, name: translate('settings.add_member_header_show_1') },
                  { id: 2, name: translate('settings.add_member_header_show_2') },
                  { id: 3, name: translate('settings.add_member_header_show_3') }
                ]} validate={[required()]} />
                <br/>
                <ColorInput fullWidth source="add_member_header_color" label={translate('settings.add_member_header_color')}  validate={[validateMaxLength(7,translate('common.validation.maxLength'))]} />                  
            </Grid> 
            <Grid item xs={4}> 
                <br/>
                <BoxPhotoUser target={targets.ADD_MEMBER_HEADER_LOGO} items_id={localStorage.getItem('associations_id')} edit={true} default_img={1} className="docs_photo_user" />                  
            </Grid> 
            </Grid>
            </> : null }
                                
            { /*!subscriptionModule(modules.RECERCAT) ?
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <BooleanInput fullWidth source="add_member_logo" label={translate('settings.add_member_logo')}  />
                </Grid>
              </Grid>  : null */ }
    
            <Typography variant="h6" className="grey8 titleUserShow">                        
              {translate('settings.add_member_texts')}
            </Typography>
            <Divider className="" />
            
            <br/>
            
            { !subscriptionModule(modules.RECERCAT) ?
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextInput className="settings_add_member_lopd" fullWidth multiline source="add_member_title" label={translate('settings.add_member_title')}  />
              </Grid>
            </Grid> : null }
            
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextInput className="settings_add_member_lopd" fullWidth multiline source="add_member_form_text" label={translate('settings.add_member_form_text')}  />
              </Grid>
            </Grid>
            
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextInput className="settings_add_member_lopd" fullWidth multiline source="add_member_lopd" label={translate('settings.add_member_lopd')}  />
              </Grid>
            </Grid>
                          
            { !subscriptionModule(modules.RECERCAT) ?
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <TextInput fullWidth className="settings_add_member_lopd" multiline source="add_member_confirmation" label={translate('settings.add_member_confirmation')}  />
                </Grid>
              </Grid> : null }
                
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextInput className="settings_add_member_lopd" fullWidth multiline source="add_member_form_sent" label={translate('settings.add_member_form_sent')}  />
              </Grid>
            </Grid>            
            
            { !subscriptionModule(modules.RECERCAT) ?
            <>
            <Typography variant="h6" className="grey8 titleUserShow">                        
              {translate('settings.add_member_fields')}
            </Typography>
            <Divider className="" />            
            
            <ArrayInput source="add_member_fields" label="" >
                <SimpleFormIterator disableReordering
                        inline
                        disableRemove
                        disableAdd
                        disableReordering={false}
                        className="simple-iterator-inline2" 
                        getItemKey={(record) => record.id} 
                        getItemLabel={index => ''} >
                        
                        <FormDataConsumer>
                          {({ formData, scopedFormData, getSource, ...rest }) => true &&
                            <>
                            <span>{translate('users.' + scopedFormData?.name )}</span>
                            
                            <TextInput source={getSource('name')} label="" style={{ display: 'none' }} />

                            { scopedFormData?.name !== 'custom_fields' ?
                            <BooleanInput source={getSource('actived')} label={translate('custom_fields.actived')} disabled={scopedFormData?.name === 'lopd' ? true : false} />
                            : <span/> }

                            { scopedFormData?.name !== 'custom_fields' ?
                            <BooleanInput source={getSource('required')} label={translate('custom_fields.required')} disabled={scopedFormData?.name === 'lopd' ? true : false} />
                            : <span/> }
                            </>
                          }
                        </FormDataConsumer>
                </SimpleFormIterator>
            </ArrayInput>
            </>
            : null }
                          
            { /*!subscriptionModule(modules.RECERCAT) ?
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <BooleanInput fullWidth source="add_member_bank_data" label={translate('settings.add_member_bank_data')}  />
                </Grid>
              </Grid> : null */ }
            
            { !subscriptionModule(modules.RECERCAT) ?
            <>
            <Typography variant="h6" className="grey8 titleUserShow">                        
              {translate('settings.add_member_actions')}
            </Typography>
            <Divider className="" />   
            </>
            : null }
            
            <br/>
              
            { !subscriptionModule(modules.RECERCAT) ?
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <BooleanInput fullWidth source="add_member_validate_email" label={translate('settings.add_member_validate_email')}  />
                </Grid>
            </Grid> : null }
            
            { !subscriptionModule(modules.RECERCAT) ?
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <BooleanInput fullWidth source="add_member_notification" label={translate('settings.add_member_notification')}  />
                </Grid>
                <FormDataConsumer>
                  {({ formData, ...rest }) => formData.add_member_notification &&
                    <>
                      <Grid item xs={12}>
                        <RadioButtonGroupInput
                          label={translate('settings.add_member_notification_destination')}
                          row={false}
                          source="add_member_notification_destination"
                          choices={[
                            { id: 0, name: translate('settings.add_member_notification_destination_entity') + ' (' + (info.email || translate('settings.add_member_notification_no_entity_email')) + ')' },
                            { id: 1, name: translate('settings.add_member_notification_destination_custom') }
                          ]}
                          validate={[required()]}
                        />
                      </Grid>
                      {Number(formData.add_member_notification_destination || 0) === 1 ?
                        <Grid item xs={12}>
                          <TextInput
                            fullWidth
                            source="add_member_notification_email"
                            label={translate('settings.add_member_notification_email')}
                            validate={[required()]}
                          />
                        </Grid>
                      : null}
                    </>
                  }
                </FormDataConsumer>
              </Grid> : null }                 
            
            <br/>
            <SaveButton
              saving={formProps.saving}
              handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
            />
          </Box>      

        </>
            
      )}
    />
    
  );
  
};


export const SettingsClassroomRequests = ( props ) => {
    
  var translate = useTranslate();
  const history = useHistory();
  const dataProvider = useDataProvider();
  const [info, setInfo] = useState();
    
  const [showDialog, setShowDialog] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();  
  const [update, { loading, error }] = useUpdate();
    
  let formUrl = '/public/classrooms-requests/' + localStorage.getItem('friendly_url');
  let formCompleteUrl = projectUrl + '/#' + formUrl;
    
  useEffect(() => {
    if (localStorage.getItem('associations_id') > 0)
    {
      dataProvider.getOne('associations', { id: localStorage.getItem('associations_id') })
        .then(({ data }) => {    
          setInfo(data);
        })
        .catch(error => {                                
        });
    }
  }, []);

  if (!info) return null;
    
  const handleSubmit = async values => {
    update(
      { 
        type: 'update', 
        resource: 'associations/classrooms-requests', 
        payload : { id: values.id, data : { 
          classrooms_requests_actived : values.classrooms_requests_actived,
          classrooms_requests_logo : values.classrooms_requests_logo,
          classrooms_requests_text : values.classrooms_requests_text,
          classrooms_requests_notification : values.classrooms_requests_notification,
          classrooms_requests_lopd : values.classrooms_requests_lopd,
          classrooms_requests_form_sent : values.classrooms_requests_form_sent
        } }
      },
      {
        onSuccess: ({ data }) => {
          history.push('/settings');
        },
        onFailure: ( error ) => {
          notify(error.message, 'error');
        }
      }
    );
  };    
    
  const handleClick = (e) => {
    e.preventDefault();
    setShowDialog(true);
  };
  const handleCloseClick = () => {
    setShowDialog(false);
  };
    
  return (
        
    <FormWithRedirect
      resource="associations"        
      save={handleSubmit}
      initialValues={{ id : localStorage.getItem('associations_id'), 
        classrooms_requests_actived : info.classrooms_requests_actived,
        classrooms_requests_logo : info.classrooms_requests_logo,
        classrooms_requests_text : info.classrooms_requests_text,
        classrooms_requests_notification : info.classrooms_requests_notification,
        classrooms_requests_lopd : info.classrooms_requests_lopd,
        classrooms_requests_form_sent : info.classrooms_requests_form_sent
      }}
      render={formProps => (
            
        <>
          <br/>
          <Typography variant="h5" className="grey8" align="center">
            {translate('settings.classrooms_requests')}              
          </Typography>  
            
          <Box sx={{ width: '100%', maxWidth: 800, bgcolor: 'background.paper', padding: '25px' }} className="settings_box" >
                
            <Grid container spacing={1}>
              <Grid item xs={12}>
                      
              </Grid>
            </Grid> 
                
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <BooleanInput label={translate('settings.classrooms_requests_actived')} fullWidth source="classrooms_requests_actived"  />
              </Grid>
            </Grid>   
                
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <BooleanInput fullWidth source="classrooms_requests_logo" label={translate('settings.classrooms_requests_logo')}  />
              </Grid>
            </Grid>  
                
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <BooleanInput fullWidth source="classrooms_requests_notification" label={translate('settings.classrooms_requests_notification')}  />
              </Grid>
            </Grid>
                
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextInput className="classrooms_requests_lopd" fullWidth multiline source="classrooms_requests_text" label={translate('settings.classrooms_requests_text')}  />
              </Grid>
            </Grid>
                
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextInput className="classrooms_requests_lopd" fullWidth multiline source="classrooms_requests_lopd" label={translate('settings.classrooms_requests_lopd')}  />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextInput className="settings_add_member_lopd" fullWidth multiline source="classrooms_requests_form_sent" label={translate('settings.classrooms_requests_form_sent')}  />
              </Grid>
            </Grid>
                
            <SaveButton
              saving={formProps.saving}
              handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
            />
                
            <br/><br/>
            <ShowButton 
              component={Link}
              to={formUrl}
              label={translate('settings.classrooms_requests_view_form')}
              target="_blank"
              align="right"
              className
            />   
            <br/><br/><a onClick={handleClick} href="">    
              {translate('settings.classrooms_requests_help')}
            </a>
                
            <Dialog
              fullWidth
              open={showDialog}
              onClose={handleCloseClick}
              aria-label=""
            >
              <DialogTitle>
                {translate('settings.classrooms_requests_help')}
                <IconButton
                  aria-label="close"
                  onClick={handleCloseClick}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
                
              <DialogContent>
                {translate('settings.classrooms_requests_help_1')}
                <br/>
                <br/>
                <br/><i>
                    &lt;iframe 
                        style="width: 100%; height: 100%; border: none; margin: 0; padding: 0; overflow: scroll-y;" 
                        src="{formCompleteUrl}" /&gt;                        
                </i><br/><br/><br/>
              </DialogContent>

            </Dialog>
                
                

          </Box>
        </>
            
      )}
    />
    
  );
  
};

export const SettingsAnnuaryForm = ( props ) => {
    
  var translate = useTranslate();
  const history = useHistory();
  const dataProvider = useDataProvider();
  const [info, setInfo] = useState();
    
  const [showDialog, setShowDialog] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();  
  const [update, { loading, error }] = useUpdate();
        
  useEffect(() => {
    if (localStorage.getItem('associations_id') > 0)
    {
      dataProvider.getOne('associations', { id: localStorage.getItem('associations_id') })
        .then(({ data }) => {    
          setInfo(data);
        })
        .catch(error => {                                
        });
    }
  }, []);

  if (!info) return null;
    
  const handleSubmit = async values => {
    update(
      { 
        type: 'update', 
        resource: 'associations/annuary-form', 
        payload : { id: values.id, data : { 
          annuary_form_logo : values.annuary_form_logo,
          annuary_form_text : values.annuary_form_text,
          annuary_form_notification : values.annuary_form_notification,
          annuary_form_notification_association : values.annuary_form_notification_association,
          annuary_form_notification_num_members : values.annuary_form_notification_num_members,
          annuary_form_lopd : values.annuary_form_lopd,
          annuary_form_sent : values.annuary_form_sent
        } }
      },
      {
        onSuccess: ({ data }) => {
          history.push('/settings');
        },
        onFailure: ( error ) => {
          notify(error.message, 'error');
        }
      }
    );
  };    
        
  return (
                        
    <FormWithRedirect
      resource="associations"        
      save={handleSubmit}
      initialValues={{ id : localStorage.getItem('associations_id'), 
        annuary_form_logo : info.annuary_form_logo,
        annuary_form_text : info.annuary_form_text,
        annuary_form_notification : info.annuary_form_notification,
        annuary_form_notification_association : info.annuary_form_notification_association,
        annuary_form_notification_num_members : info.annuary_form_notification_num_members,
        annuary_form_lopd : info.annuary_form_lopd,
        annuary_form_sent : info.annuary_form_sent
      }}
      render={formProps => (
            
        <>
          <br/>
          <Typography variant="h5" className="grey8" align="center">
            {translate('settings.annuary_form')}              
          </Typography>  
            
          <Box sx={{ width: '100%', maxWidth: 800, bgcolor: 'background.paper', padding: '25px' }} className="settings_box" >
                
            <Grid container spacing={1}>
              <Grid item xs={12}>
                      
              </Grid>
            </Grid> 
                
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <BooleanInput fullWidth source="annuary_form_logo" label={translate('settings.annuary_form_logo')}  />
              </Grid>
            </Grid>  
                
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <BooleanInput fullWidth source="annuary_form_notification" label={translate('settings.annuary_form_notification')}  />
              </Grid>
            </Grid>
                
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <BooleanInput fullWidth source="annuary_form_notification_association" label={translate('settings.annuary_form_notification_association')}  />
              </Grid>
            </Grid>
                
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <BooleanInput fullWidth source="annuary_form_notification_num_members" label={translate('settings.annuary_form_notification_num_members')}  />
              </Grid>
            </Grid>
                
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextInput className="classrooms_requests_lopd" fullWidth multiline source="annuary_form_text" label={translate('settings.annuary_form_text')}  />
              </Grid>
            </Grid>
                
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextInput className="classrooms_requests_lopd" fullWidth multiline source="annuary_form_lopd" label={translate('settings.annuary_form_lopd')}  />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextInput className="settings_add_member_lopd" fullWidth multiline source="annuary_form_sent" label={translate('settings.annuary_form_sent')}  />
              </Grid>
            </Grid>
                
            <SaveButton
              saving={formProps.saving}
              handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
            />

          </Box>
        </>
            
      )}
    />
    
  );
  
};


export const SettingsDonationsCertificates = ( props ) => {
    
  var translate = useTranslate();
  const history = useHistory();
  const dataProvider = useDataProvider();
  const [info, setInfo] = useState();
    
  const [showDialog, setShowDialog] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();  
  const [update, { loading, error }] = useUpdate();
        
  useEffect(() => {
    if (localStorage.getItem('associations_id') > 0)
    {
      dataProvider.getOne('associations', { id: localStorage.getItem('associations_id') })
        .then(({ data }) => {    
          setInfo(data);
        })
        .catch(error => {                                
        });
    }
  }, []);

  if (!info) return null;
    
  const handleSubmit = async values => {
    update(
      { 
        type: 'update', 
        resource: 'associations/donations_certificates', 
        payload : { id: values.id, data : values }
      },
      {
        onSuccess: ({ data }) => {
          history.push('/settings');
        },
        onFailure: ( error ) => {
          notify(error.message, 'error');
        }
      }
    );
  };    
        
  return (
                        
    <FormWithRedirect
      resource="associations"        
      save={handleSubmit}
      initialValues={{ id : localStorage.getItem('associations_id'), ...info
      }}
      render={formProps => (
            
        <>
          <br/>
          <Typography variant="h5" className="grey8" align="center">
            {translate('settings.donations_certificates')}              
          </Typography>  
            
          <Box sx={{ width: '100%', maxWidth: 800, bgcolor: 'background.paper', padding: '25px' }} className="settings_box" >
                
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <BooleanInput
                      fullWidth
                      source="donations_users_certificate_confirmation"
                      label={translate('settings.donations_certificates_confirmation')}
                    />
                </Grid>
                <Grid item xs={12}>   
                    <TextInput fullWidth multiline source="donations_users_certificate" label={translate('settings.donations_certificates_donations_users_certificate')} />
                </Grid> 
                <Grid item xs={12}> 
                    <b>{translate('settings.donations_certificates_donations_users_certificate_vars_title')}</b> <br/>
                    {translate('settings.donations_certificates_donations_users_certificate_vars')}
                    <br/><br/>
                </Grid>
                <Grid item xs={3}> 
                    <Grid container spacing={1}>
                        <Grid item xs={12}> 
                            <Typography variant="h6" className="grey8" align="">
                                {translate('settings.donations_certificates_header')}              
                            </Typography>
                        </Grid>
                        <Grid item xs={12}> 
                            <BoxPhotoUser target={targets.DONATION_CERTIFICATE_HEADER} items_id={localStorage.getItem('associations_id')} edit={true} default_img={-1} className="docs_photo_user" />   
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={1}></Grid> 
                <Grid item xs={3}> 
                    <Grid container spacing={1}>
                        <Grid item xs={12}> 
                            <Typography variant="h6" className="grey8" align="">
                                {translate('settings.donations_certificates_sign')}              
                            </Typography>
                        </Grid>
                        <Grid item xs={12}> 
                            <BoxPhotoUser target={targets.DONATION_CERTIFICATE_SIGN} items_id={localStorage.getItem('associations_id')} edit={true} default_img={-1} className="docs_photo_user" />   
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={1}></Grid> 
                <Grid item xs={3}> 
                    <Grid container spacing={1}>
                        <Grid item xs={12}> 
                            <Typography variant="h6" className="grey8" align="">
                                {translate('settings.donations_certificates_footer')}              
                            </Typography>
                        </Grid>
                        <Grid item xs={12}> 
                            <BoxPhotoUser target={targets.DONATION_CERTIFICATE_FOOTER} items_id={localStorage.getItem('associations_id')} edit={true} default_img={-1} className="docs_photo_user" />   
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>  
            <br /><br />    
            <SaveButton
              saving={formProps.saving}
              handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
            />

          </Box>
        </>
            
      )}
    />
    
  );
  
};


export const SettingsUsers = ( props ) => {
    
  var translate = useTranslate();
    
  return (        
    <>      
    <br/>
    <Typography variant="h5" className="grey8" align="center">
      {translate('settings.users')}              
    </Typography>  
    <Box sx={{ bgcolor: 'background.paper', padding: '20px' }} className="settings_box" >
                
      <PermissionsList associations_id={localStorage.getItem('associations_id')} redirect="/settings-users" {...props} />
    
    </Box>
    </>
    
  );
  
};

export const SettingsTicketsUsers = ( props ) => {
    
  var translate = useTranslate();
    
  return (        
    <>      
    <br/>
    <Typography variant="h5" className="grey8" align="center">
      {translate('settings.tickets_users')}              
    </Typography>  
    <Box sx={{ bgcolor: 'background.paper', padding: '20px' }} className="settings_box" >
                
      <PermissionsList associations_id={localStorage.getItem('associations_id')} redirect="/settings-tickets-users" {...props} context={contexts.TICKETS} />
    
    </Box>
    </>
    
  );
  
};

export const SettingsNotAvailable = ( props ) => {
    
  var translate = useTranslate();
    
  return (        
    <Box sx={{ width: '100%', maxWidth: 500, bgcolor: 'background.paper', padding: '25px' }} className="settings_box not_available" >
                
      <Grid container spacing={1}>
        <Grid item xs={12} align="center">
              Opció temporalment no disponible
        </Grid>
      </Grid>   
    
    </Box>
    
  );
  
};


const ResourceName = () => {
  const { resource } = useResourceContext();
  return <>{resource}</>;
};

const groupConfigurableEmailTemplates = ['WELCOME', 'GROUP_LEFT', 'DIGITAL_CARD_SEND'];

export const SettingsEmails = ( props ) => {
    
  var translate = useTranslate();
  const history = useHistory();
  const dataProvider = useDataProvider();
  const [info, setInfo] = useState();
  const [groups, setGroups] = useState([]);
    
  /*
    const [showDialog, setShowDialog] = useState(false);
    const notify = useNotify();
    const refresh = useRefresh();  
    const [update, { loading, error }] = useUpdate();*/
    
  const { data, ids, loading, error } = useGetList(
    'templates',
    { page: 1, perPage: 1000 },
    { field: 'priority', order: 'ASC' },
    { associations_id : localStorage.getItem('associations_id'), include_variants: 1 }
  );

  useEffect(() => {
    dataProvider.getList('groups', {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'priority', order: 'ASC' },
      filter: { associations_id: localStorage.getItem('associations_id') }
    })
      .then(({ data }) => setGroups(data || []))
      .catch(error => {});
  }, []);
      
  var gestioAvailableTemplates = ['SKELETON','WELCOME','GROUP_LEFT','USER_VALIDATE_EMAIL','USER_REQUEST_DENIED','USER_REQUEST_OK'];
  var federationAvailableTemplates = ['ANNUARY_SEND', 'ANNUARY_REMINDER','ANNUARY_CONFIRM', 'DONATIONS_USERS_CONFIRMATION', 'DONATIONS_USERS_CERTIFICATE', 'DONATIONS_USERS_PRE_CONFIRMATION_TRANSFER'];
  var digitalCardsAvailableTemplates = ['DIGITAL_CARD_SEND'];
  var remittancesAvailableTemplates = ['RECEIVE_RETURNED', 'RECEIVE_RETURNED_CASH','DONATIONS_USERS_CERTIFICATE'];
  var calendarAvailableTemplates = ['EVENT_INVITE', 'EVENT_REMINDER'];  
  var recercatAvailableTemplates = ['SKELETON', 'USER_VALIDATE_EMAIL','RECERCAT_CENTER_RESUME','USER_REQUEST_DENIED','RECERCAT_REQUEST_DENIED_BY_CENTER','RECERCAT_CARD_REVOKED_BY_IRMU','RECERCAT_CARD_REVOKED_BY_CENTER','RECERCAT_IRMU_RESUME','RECERCAT_CARD_REVOKED_BY_IRMU_CENTER_DELETED','RECERCAT_USER_REQUEST_KO','USER_REQUEST_OK'];
  var donationsOwnAvailableTemplates = ['DONATIONS_USERS_PRE_CONFIRMATION_TRANSFER', 'DONATIONS_USERS_CONFIRMATION','DONATIONS_USERS_CERTIFICATE'];  
        
  if (loading) { return <MyLoading />; }
  if (error) { return <p>ERROR</p>; }
  
  const isSuperAdmin = ['SIFAC'].includes(localStorage.getItem('permissions_groups'));
  const groupsById = groups.reduce((acc, group) => {
    acc[group.id] = group;
    return acc;
  }, {});
              
  return (
        
    <>
      <br/>
      <Typography variant="h5" className="grey8" align="center">
        {translate('settings.emails')}              
      </Typography>

      <Box sx={{ width: '100%', maxWidth: 500, bgcolor: 'background.paper', padding: '25px' }} className="settings_box" >
        <List>
          {ids.map(id => {
            let link = '/settings-emails/' + id;
            let public_id = data[id].public_id;
            let group = data[id].groups_id ? groupsById[data[id].groups_id] : null;
            let templateLink = {
              pathname: link,
              state: group ? { groupName: group.name } : {}
            };
            let title = translate('settings.emails_' + data[id].public_id);
            let subtitle = isSuperAdmin && !data[id].groups_id ? translate('settings.emails_' + data[id].public_id + '_desc') : null;
            if (data[id].groups_id) subtitle = translate('settings.emails_group_variant_title') + ' ' + (group ? group.name : data[id].groups_id);
            /* Mostrem els templates a modificar segons les subscripcions de l'entitat */            
            if ( isSuperAdmin ||
                 subscriptionModule(modules.GESTIO) && gestioAvailableTemplates.indexOf(public_id) > -1 ||
                 subscriptionModule(modules.FEDERATION) && federationAvailableTemplates.indexOf(public_id) > -1 ||
                 subscriptionModule(modules.CALENDAR) && calendarAvailableTemplates.indexOf(public_id) > -1 ||
                 (subscriptionModule(modules.DIGITAL_CARDS) || subscriptionModule(modules.WALLETS)) && digitalCardsAvailableTemplates.indexOf(public_id) > -1 ||
                 subscriptionModule(modules.REMITTANCES) && remittancesAvailableTemplates.indexOf(public_id) > -1 ||
                 subscriptionModule(modules.DONATIONS,modulesOptions.DONATIONS_OWN) && donationsOwnAvailableTemplates.indexOf(public_id) > -1 ||
                 subscriptionModule(modules.RECERCAT) && recercatAvailableTemplates.indexOf(public_id) > -1 )
              return(
                <ListItem>
                  <ListItemButton component={Link} to={templateLink}>
                    <ListItemIcon>
                      <DraftsIcon />
                    </ListItemIcon>
                    <ListItemText primary={title} secondary={subtitle}  />
                  </ListItemButton>
                </ListItem>
              );
            else
              return null;
          }
          )}
        </List>
      </Box>
    </>
    
  );
  
};

const SettingsEmailsGroupVariantCreateButton = ({ template }) => {
    
  const translate = useTranslate();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const [groups, setGroups] = useState([]);
  const [variants, setVariants] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const associationsId = localStorage.getItem('associations_id');

  const loadData = () => {
    if (!template || !template.public_id || !associationsId) return;

    setLoading(true);
    Promise.all([
      dataProvider.getList('groups', {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: 'priority', order: 'ASC' },
        filter: { associations_id: associationsId }
      }),
      dataProvider.getList('templates', {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: 'priority', order: 'ASC' },
        filter: { associations_id: associationsId, public_id: template.public_id, only_group_variants: 1 }
      })
    ])
      .then(([groupsResponse, variantsResponse]) => {
        setGroups(groupsResponse.data || []);
        setVariants(variantsResponse.data || []);
      })
      .catch(error => notify(error.message, 'error'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadData();
  }, [template && template.id]);

  const groupsById = groups.reduce((acc, group) => {
    acc[group.id] = group;
    return acc;
  }, {});
  const usedGroups = variants.map(item => item.groups_id);
  const availableGroups = groups.filter(group => usedGroups.indexOf(group.id) === -1);

  const handleCreate = values => {
    setLoading(true);
    dataProvider.create('templates', {
      data: {
        associations_id: associationsId,
        public_id: template.public_id,
        groups_id: values.groups_id,
        lang: template.lang,
        subject: template.subject,
        content: template.content,
        sender_name: template.sender_name,
        sender_email: template.sender_email,
        senders_id: template.senders_id,
        reply_to: template.reply_to,
        cc: template.cc,
        bcc: template.bcc
      }
    })
      .then(({ data }) => {
        const group = groupsById[values.groups_id];
        setShowDialog(false);
        notify(translate('ra.notification.created'));
        history.push({
          pathname: '/settings-emails/' + data.id,
          state: {
            groupName: group ? group.name : values.groups_id
          }
        });
      })
      .catch(error => notify(error.message, 'error'))
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Button
          label={translate('settings.emails_group_variant_customize')}
          onClick={() => setShowDialog(true)}
          disabled={loading || availableGroups.length === 0}
        >
          <AddCircleOutlineIcon />
        </Button>
      </Box>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={() => setShowDialog(false)}
        aria-label={translate('settings.emails_group_variant_customize')}
        maxWidth="sm"
      >
        <DialogTitle>{translate('settings.emails_group_variant_customize')}</DialogTitle>
        <FormWithRedirect
          resource="templates"
          save={handleCreate}
          initialValues={{ groups_id: availableGroups.length ? availableGroups[0].id : null }}
          render={formProps => (
            <>
              <DialogContent>
                <SelectInput
                  fullWidth
                  source="groups_id"
                  label={translate('settings.emails_group_variant_group')}
                  choices={availableGroups}
                  optionText="name"
                  optionValue="id"
                  validate={[required()]}
                />
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={() => setShowDialog(false)} disabled={loading}>
                  <IconCancel />
                </Button>
                <SaveButton
                  saving={formProps.saving || loading}
                  handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};


export const SettingsEmailsItem = ( props ) => {
    
  var translate = useTranslate();
  const classes = useStyles();
  const history = useHistory();
  const dataProvider = useDataProvider();
  const [info, setInfo] = useState();
  const [savingTemplate, setSavingTemplate] = useState(false);
  const [groupInfo, setGroupInfo] = useState();
    
  const [showDialog, setShowDialog] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();  
  const loading = savingTemplate;
  
  const [customFields, setCustomFields] = useState();
  const [error2, setError2] = useState(false);  
  
  var availableCustomFieldsTemplates = ['WELCOME','GROUP_LEFT','DIGITAL_CARD_SEND'];  
        
  useEffect(() => {
    setInfo();
    setGroupInfo();
      
    dataProvider.getOne('templates', { id: props.match.params.id })
      .then(({ data }) => {    
        setInfo(data);
        if (data.groups_id) {
          dataProvider.getOne('groups', { id: data.groups_id })
            .then(({ data }) => setGroupInfo(data))
            .catch(error => {});
        }
      })
      .catch(error => {                                
      });
    
    if (subscriptionModule(modules.CUSTOM_FIELDS))  
    {
        fetchCustomFields(localStorage.getItem('associations_id'), targets.USER, setCustomFields, setError2, dataProvider, false, false );        
    }
    
  }, [props.match.params.id]);

  if (!info || (subscriptionModule(modules.CUSTOM_FIELDS) && !customFields)) return null;
  const routeState = props.location && props.location.state ? props.location.state : {};
  const isGroupVariant = !!info.groups_id;
  const groupName = routeState.groupName ? routeState.groupName : (groupInfo ? groupInfo.name : info.groups_id);
  const returnPath = '/settings-emails';
  const canConfigureGroupVariants =
    localStorage.getItem('associations_id') > 0 &&
    !info.groups_id &&
    groupConfigurableEmailTemplates.indexOf(info.public_id) > -1;
    
  const handleSubmit = async values => {
    setSavingTemplate(true);
    dataProvider.update('templates', {
        id: values.id,
        data : { 
          public_id: info.public_id,
          groups_id: info.groups_id,
          lang: info.lang,
          subject : values.subject,
          content : values.content,
          sender_name : values.sender_name,
          sender_email : values.sender_email,
          senders_id : values.senders_id,
          reply_to : values.reply_to,
          cc : values.cc,
          bcc : values.bcc,
        },
        previousData: info
      })
      .then(() => {
        history.push(returnPath);
      })
      .catch(error => {
        notify(error.message, 'error');
      })
      .finally(() => setSavingTemplate(false));
  };    
    
  const handleCloseClick = () => {
    history.push(returnPath);
  };

  const handleDelete = () => {
    setSavingTemplate(true);
    dataProvider.delete('templates', { id: info.id, previousData: info })
      .then(() => {
        notify(translate('ra.notification.deleted', { smart_count: 1 }));
        history.push('/settings-emails');
      })
      .catch(error => {
        notify(error.message, 'error');
      })
      .finally(() => setSavingTemplate(false));
  };
    
  return (
        
    <FormWithRedirect
      resource="templates"        
      save={handleSubmit}
      initialValues={{ id : info.id, 
        subject : info.subject,
        content : info.content,
        sender_name : info.sender_name,
        sender_email : info.sender_email,
        senders_id: info.senders_id,
        reply_to : info.reply_to,
        cc : info.cc,
        bcc : info.bcc,
      }}
      render={formProps => (
            
        <>
          <br/>
          <Typography variant="h5" className="grey8" align="center">
            {translate('settings.emails_' + info.public_id )}              
          </Typography>
          { isGroupVariant ? 
            <Typography variant="subtitle1" className="grey8" align="center">
              {translate('settings.emails_group_variant_title')}: {groupName}
            </Typography> : null }
            
          <Box sx={{ width: '100%', maxWidth: 950, bgcolor: 'background.paper', padding: '10px' }} className="settings_box" >
            { canConfigureGroupVariants ? 
              <SettingsEmailsGroupVariantCreateButton template={info} /> : null }
                
            <TabbedShowLayout
              syncWithLocation={false}>
           
              <Tab
                label={translate('settings.emails_message')}
                contentClassName={classes.tab}
                fullWidth
                path=""
              >                 
                <br />
                    
                { info.public_id !== 'SKELETON' && info.public_id !== 'SA_SKELETON' ? 
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <TextInput fullWidth source="subject" label={translate('settings.emails_subject')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                    </Grid>
                  </Grid>  
                  : <span/> }

                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <TextInput multiline fullWidth source="content" label={translate('settings.emails_content')} />                              
                  </Grid>
                </Grid>
                    
                <Grid item xs={12}>
                  <b>{translate('settings.emails_vars')}</b> <br/>
                  {translate('settings.emails_' + info.public_id + '_vars')}
                  {info.context === contexts.TICKETS ? ' | %project_name%' : ''}
                  <br /><br/>  
                       
                  { subscriptionModule(modules.CUSTOM_FIELDS) && availableCustomFieldsTemplates.includes(info.public_id) ?
                    <>
                    <u>{translate('custom_fields.main_menu_title')}</u>
                    {
                      customFields.map((element, index) => {
                        if (element.type != 9 && element.type != 10)
                        {
                            return (
                              <>
                                <br />
                                {element.name}: %custom_field_{element.id}%
                              </>
                            );
                        }
                        else return ('');                        
                      })
                    }
                    </> : null 
                  }
                </Grid>

                <DialogActions>
                  { isGroupVariant ?
                    <Button
                      label="ra.action.delete"
                      onClick={() => setShowDeleteDialog(true)}
                      disabled={loading}
                      style={{ color: '#c62828' }}
                    >
                      <DeleteIcon />
                    </Button> : null }
                  <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                    <IconCancel />
                  </Button>
                  <SaveButton
                    saving={formProps.saving}
                    handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
                  />
                </DialogActions>
                <Dialog
                  fullWidth
                  open={showDeleteDialog}
                  onClose={() => setShowDeleteDialog(false)}
                  aria-label={translate('settings.emails_group_variant_delete_title')}
                  maxWidth="sm"
                >
                  <DialogTitle>{translate('settings.emails_group_variant_delete_title')}</DialogTitle>
                  <DialogContent>
                    {translate('settings.emails_group_variant_delete_confirm')}
                  </DialogContent>
                  <DialogActions>
                    <Button label="ra.action.cancel" onClick={() => setShowDeleteDialog(false)} disabled={loading}>
                      <IconCancel />
                    </Button>
                    <Button
                      label="ra.action.delete"
                      onClick={handleDelete}
                      disabled={loading}
                      style={{ color: '#c62828' }}
                    >
                      <DeleteIcon />
                    </Button>
                  </DialogActions>
                </Dialog>
                    
              </Tab>
                
              { info.public_id !== 'SKELETON' && info.public_id !== 'SA_SKELETON' ? 
                <Tab
                  label={translate('settings.emails_attached')}
                  contentClassName={classes.tab}
                  fullWidth
                  path="docs"
                >   
                  <DocsList target={targets.TEMPLATE} items_id={info.id} />
                  <br />
                </Tab> : <span/> }
                
              { info.public_id !== 'SKELETON' && info.public_id !== 'SA_SKELETON' ? 
                <Tab
                  label={translate('settings.emails_headers')}
                  contentClassName={classes.tab}
                  fullWidth
                  path="headers"
                >   
                  <br />
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <TextInput fullWidth source="sender_name" label={translate('settings.emails_headers_sender_name')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />                              
                    </Grid>
                    <Grid item xs={6}>
                        <ReferenceInput 
                                fullWidth 
                                label={translate('settings.emails_headers_sender_email')} 
                                source="senders_id" 
                                reference="senders" 
                                filter={ localStorage.getItem('associations_id') > 0
                                  ? { associations_id: localStorage.getItem('associations_id'), only_actived: 1 }
                                  : { associations_id: 0, only_actived: 1, context: info.context, exclude_platform_role: 'PLATFORM_SMTP' }
                                } 
                                perPage={1000}
                                sort={{ field: 'id', order: 'ASC' }}
                        >
                               <SelectInput optionText={record => record && Number(record.type) === 0 ? translate('senders.platform_sender') : record.email} optionValue="id" validate={[required()]} />
                        </ReferenceInput>   
                    </Grid>
                  </Grid>
                    
                  <Grid container spacing={1}>                    
                    <Grid item xs={4}>
                      <TextInput fullWidth source="reply_to" label={translate('settings.emails_headers_reply_to')} validate={[validateMaxLength(100,translate('common.validation.maxLength'))]} />                              
                    </Grid>
                    <Grid item xs={4}>
                      <TextInput fullWidth source="cc" label={translate('settings.emails_headers_cc')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />                              
                    </Grid>
                    <Grid item xs={4}>
                      <TextInput fullWidth source="bcc" label={translate('settings.emails_headers_bcc')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />                              
                    </Grid>
                  </Grid>
                    
                  <Grid item xs={12}>
                    <b>{translate('settings.emails_vars')}</b> <br/>
                    {translate(info.context === contexts.TICKETS
                      ? 'settings.emails_headers_tickets_vars'
                      : 'settings.emails_headers_vars')}
                    <br /><br />                    
                  </Grid>
                    
                  <DialogActions>
                    <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                      <IconCancel />
                    </Button>
                    <SaveButton
                      saving={formProps.saving}
                      handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
                    />
                  </DialogActions>
                    
                  <br />
                </Tab> : <span/> }
                
            </TabbedShowLayout>
                

          </Box>
        </>
            
      )}
    />
    
  );
  
};
                    


const TaxesFormContent = () => {
  const translate = useTranslate();

  return (
    <DialogContent>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <NumberInput fullWidth source="percent" label={translate('settings.tax_percent')} validate={[required()]} />
        </Grid>
      </Grid>
    </DialogContent>
  );
};

const TaxesCreateButton = () => {
  const translate = useTranslate();
  const notify = useNotify();
  const refresh = useRefresh();
  const [showDialog, setShowDialog] = useState(false);
  const [create, { loading }] = useCreate('taxes');

  const handleSubmit = values => {
    create(
      { payload: { data: values } },
      {
        onSuccess: () => {
          setShowDialog(false);
          refresh();
          notify(translate('settings.done'), 'success');
        },
        onFailure: error => {
          notify(error.message, 'error');
        }
      }
    );
  };

  return (
    <>
      <Button onClick={() => setShowDialog(true)} label={translate('settings.add_tax')}>
        <AddCircleOutlineIcon />
      </Button>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={() => setShowDialog(false)}
        aria-label={translate('settings.add_tax')}
        maxWidth="xs"
      >
        <DialogTitle>{translate('settings.add_tax')}</DialogTitle>
        <FormWithRedirect
          resource="taxes"
          save={handleSubmit}
          initialValues={{ percent: 21 }}
          render={({ handleSubmitWithRedirect, pristine, saving }) => (
            <>
              <TaxesFormContent />
              <DialogActions>
                <Button label="ra.action.cancel" onClick={() => setShowDialog(false)} disabled={loading}>
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={handleSubmitWithRedirect}
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const TaxesListActions = () => (
  <TopToolbar>
    <TaxesCreateButton />
  </TopToolbar>
);

const TaxesEditButton = ({ record }) => {
  const translate = useTranslate();
  const notify = useNotify();
  const refresh = useRefresh();
  const [showDialog, setShowDialog] = useState(false);
  const [update, { loading }] = useUpdate();

  const handleSubmit = values => {
    update(
      {
        type: 'update',
        resource: 'taxes',
        payload: { id: values.id, data: values }
      },
      {
        onSuccess: () => {
          setShowDialog(false);
          refresh();
          notify(translate('settings.done'), 'success');
        },
        onFailure: error => {
          notify(error.message, 'error');
        }
      }
    );
  };

  return (
    <>
      <Button onClick={() => setShowDialog(true)} label="" startIcon={<EditIcon />} />

      <Dialog
        fullWidth
        open={showDialog}
        onClose={() => setShowDialog(false)}
        aria-label={translate('settings.edit_tax')}
        maxWidth="xs"
      >
        <DialogTitle>{translate('settings.edit_tax')}</DialogTitle>
        <FormWithRedirect
          resource="taxes"
          save={handleSubmit}
          initialValues={record}
          render={({ handleSubmitWithRedirect, pristine, saving }) => (
            <>
              <TaxesFormContent />
              <DialogActions>
                <Button label="ra.action.cancel" onClick={() => setShowDialog(false)} disabled={loading}>
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={handleSubmitWithRedirect}
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const TaxesDeleteButton = ({ record }) => {
  const translate = useTranslate();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirm = () => {
    setLoading(true);
    dataProvider.delete('taxes', { id: record.id })
      .then(() => {
        setLoading(false);
        setOpen(false);
        notify(translate('settings.done'), 'success');
        refresh();
      })
      .catch(error => {
        setLoading(false);
        notify(error.message, 'error');
      });
  };

  return (
    <>
      <Button label="" onClick={() => setOpen(true)} style={{ color: '#d32f2f' }}>
        <DeleteIcon />
      </Button>
      <Confirm
        isOpen={open}
        loading={loading}
        title={translate('settings.delete_tax_title')}
        content={translate('settings.delete_tax_content')}
        onConfirm={handleConfirm}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

const TaxesList = props => {
  const translate = useTranslate();

  return (
    <ResourceContextProvider value="taxes">
      <RaList
        {...props}
        basePath="/taxes"
        resource="taxes"
        actions={<TaxesListActions />}
        empty={<TaxesListActions />}
        bulkActionButtons={false}
        perPage={100}
        pagination={false}
        sort={{ field: 'percent', order: 'ASC' }}
        title=""
      >
        <Datagrid>
          <NumberField source="percent" label={translate('settings.tax_percent')} sortable={false} />
          <TaxesEditButton />
          <TaxesDeleteButton />
        </Datagrid>
      </RaList>
    </ResourceContextProvider>
  );
};

const model182InputValue = value => value && value.target
  ? value.target.value
  : value;

// React Admin 3's FormWithRedirect serializes initialValues on every render.
// A field focus can therefore make the whole screen fail if an input event is
// temporarily present in the form state. These catalog dialogs don't need
// redirects, so use Final Form directly and keep the values isolated.
const Model182Form = ({ initialValues, save, render }) =>
  <Form initialValues={initialValues} onSubmit={save}
    subscription={{ pristine: true, submitting: true, invalid: true }}
    render={({ handleSubmit, pristine, submitting, invalid }) => render({
      handleSubmitWithRedirect: () => handleSubmit(),
      pristine,
      saving: submitting,
      invalid
    })} />;

const Model182FiscalYearFormContent = () => {
  const translate = useTranslate();
  const percentageValidation = [required(), minValue(0), maxValue(100)];

  return <DialogContent>
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <NumberInput fullWidth source="year" step={1}
          label={translate('settings.model_182_fiscal_year')}
          validate={[required(), minValue(2000), maxValue(9999)]} />
      </Grid>
      <Grid item xs={12}>
        <Box sx={{ border: '1px solid #ddd', borderRadius: 1, p: 2 }}>
          <Typography variant="h6" className="grey8">
            {translate('settings.model_182_nature_1_block')}
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            {translate('settings.model_182_nature_1_block_help')}
          </Typography>
          <Typography variant="subtitle1" className="grey8" sx={{ fontWeight: 600 }}>
            {translate('settings.model_182_individuals_block')}
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <NumberInput fullWidth source="individual_first_tranche_amount" step={0.01}
                label={translate('settings.model_182_first_tranche_amount')}
                validate={[required(), minValue(0)]} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <NumberInput fullWidth source="individual_first_tranche_percentage" step={0.01}
                label={translate('settings.model_182_first_tranche_percentage')}
                validate={percentageValidation} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <NumberInput fullWidth source="individual_standard_percentage" step={0.01}
                label={translate('settings.model_182_individual_standard_percentage')}
                validate={percentageValidation} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <NumberInput fullWidth source="individual_recurring_percentage" step={0.01}
                label={translate('settings.model_182_individual_recurring_percentage')}
                validate={percentageValidation} />
            </Grid>
          </Grid>
          <Typography variant="subtitle1" className="grey8" sx={{ mt: 2, fontWeight: 600 }}>
            {translate('settings.model_182_legal_entities_block')}
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <NumberInput fullWidth source="legal_standard_percentage" step={0.01}
                label={translate('settings.model_182_legal_standard_percentage')}
                validate={percentageValidation} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <NumberInput fullWidth source="legal_recurring_percentage" step={0.01}
                label={translate('settings.model_182_legal_recurring_percentage')}
                validate={percentageValidation} />
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box sx={{ border: '1px solid #ddd', borderRadius: 1, p: 2 }}>
          <Typography variant="h6" className="grey8">
            {translate('settings.model_182_nature_2_block')}
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            {translate('settings.model_182_nature_2_block_help')}
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <NumberInput fullWidth source="nature_2_individual_percentage" step={0.01}
                label={translate('settings.model_182_nature_2_individual_percentage')}
                validate={percentageValidation} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <NumberInput fullWidth source="nature_2_legal_percentage" step={0.01}
                label={translate('settings.model_182_nature_2_legal_percentage')}
                validate={percentageValidation} />
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box sx={{ border: '1px solid #ddd', borderRadius: 1, p: 2 }}>
          <Typography variant="h6" className="grey8">
            {translate('settings.model_182_nature_3_block')}
          </Typography>
          <Typography variant="body2">
            {translate('settings.model_182_nature_3_block_help')}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box sx={{ border: '1px solid #ddd', borderRadius: 1, p: 2 }}>
          <Typography variant="h6" className="grey8">
            {translate('settings.model_182_nature_4_block')}
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            {translate('settings.model_182_nature_4_block_help')}
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <NumberInput fullWidth source="nature_4_affiliation_percentage" step={0.01}
                label={translate('settings.model_182_nature_4_affiliation_percentage')}
                validate={percentageValidation} />
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  </DialogContent>;
};

const model182FiscalYearCopyFields = [
  'individual_first_tranche_amount',
  'individual_first_tranche_percentage',
  'individual_standard_percentage',
  'individual_recurring_percentage',
  'legal_standard_percentage',
  'legal_recurring_percentage',
  'nature_2_individual_percentage',
  'nature_2_legal_percentage',
  'nature_4_affiliation_percentage'
];

const model182FiscalYearPayload = values => ({
  year: Number(model182InputValue(values.year)),
  individual_first_tranche_amount: Number(model182InputValue(values.individual_first_tranche_amount)),
  individual_first_tranche_percentage: Number(model182InputValue(values.individual_first_tranche_percentage)),
  individual_standard_percentage: Number(model182InputValue(values.individual_standard_percentage)),
  individual_recurring_percentage: Number(model182InputValue(values.individual_recurring_percentage)),
  legal_standard_percentage: Number(model182InputValue(values.legal_standard_percentage)),
  legal_recurring_percentage: Number(model182InputValue(values.legal_recurring_percentage)),
  nature_2_individual_percentage: Number(model182InputValue(values.nature_2_individual_percentage)),
  nature_2_legal_percentage: Number(model182InputValue(values.nature_2_legal_percentage)),
  nature_4_affiliation_percentage: Number(model182InputValue(values.nature_4_affiliation_percentage))
});

const Model182CopyInput = ({ label, noneLabel, choices, selectedId, onChange }) => {
  return <DialogContent style={{ paddingTop: 8, paddingBottom: 24, overflow: 'visible' }}>
    <MuiTextField select fullWidth margin="normal" variant="filled" value={selectedId}
      style={{ minHeight: 56 }}
      label={label} onChange={event => onChange(Number(event.target.value))}>
      <MenuItem value={0}>{noneLabel}</MenuItem>
      {(choices || []).map(choice => <MenuItem key={choice.id} value={choice.id}>
        {choice.name}
      </MenuItem>)}
    </MuiTextField>
  </DialogContent>;
};

const model182FiscalYearInitialValues = source => {
  const initialValues = {};
  if (source) {
    model182FiscalYearCopyFields.forEach(field => {
      initialValues[field] = source[field];
    });
  }
  return initialValues;
};

const Model182FiscalYearCreateButton = () => {
  const translate = useTranslate();
  const notify = useNotify();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);
  const [copyFromId, setCopyFromId] = useState(0);
  const [create, { loading }] = useCreate('donations_model_182_fiscal_years');
  const fiscalYearsResult = useGetList(
    'donations_model_182_fiscal_years',
    { page: 1, perPage: 100 },
    { field: 'year', order: 'DESC' },
    {}
  );
  const fiscalYears = (fiscalYearsResult.ids || [])
    .map(id => fiscalYearsResult.data[id])
    .filter(Boolean);
  const copySource = fiscalYears.find(item => item.id === copyFromId);
  const copyChoices = fiscalYears.map(item => ({ id: item.id, name: String(item.year) }));
  const handleClose = () => {
    setOpen(false);
    setCopyFromId(0);
  };

  const handleSubmit = values => {
    const data = model182FiscalYearPayload(values);
    return create({ payload: { data } }, {
      onSuccess: () => {
        handleClose();
        refresh();
        notify(translate('settings.done'), 'success');
      },
      onFailure: error => notify(error.message, 'error')
    });
  };

  return <>
    <Button onClick={() => setOpen(true)} label={translate('settings.model_182_add_fiscal_year')}>
      <AddCircleOutlineIcon />
    </Button>
    <Dialog fullWidth maxWidth="md" open={open} onClose={handleClose}
      aria-label={translate('settings.model_182_add_fiscal_year')}>
      <DialogTitle>{translate('settings.model_182_add_fiscal_year')}</DialogTitle>
      <Model182Form key={`model-182-fiscal-year-${copyFromId}`} save={handleSubmit}
        initialValues={model182FiscalYearInitialValues(copySource)}
        render={({ handleSubmitWithRedirect, pristine, saving }) => <>
          <Model182CopyInput selectedId={copyFromId} choices={copyChoices}
            label={translate('settings.model_182_copy_from_question')}
            noneLabel={translate('settings.model_182_copy_from_none')}
            onChange={setCopyFromId} />
          <Model182FiscalYearFormContent />
          <DialogActions>
            <Button label="ra.action.cancel" onClick={handleClose} disabled={loading}>
              <IconCancel />
            </Button>
            <SaveButton handleSubmitWithRedirect={handleSubmitWithRedirect} pristine={pristine}
              saving={saving} disabled={loading} />
          </DialogActions>
        </>} />
    </Dialog>
  </>;
};

const Model182FiscalYearEditButton = ({ record }) => {
  const translate = useTranslate();
  const notify = useNotify();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);
  const [update, { loading }] = useUpdate();

  const handleSubmit = values => update({
    type: 'update', resource: 'donations_model_182_fiscal_years',
    payload: { id: record.id, data: model182FiscalYearPayload(values) }
  }, {
    onSuccess: () => {
      setOpen(false);
      refresh();
      notify(translate('settings.done'), 'success');
    },
    onFailure: error => notify(error.message, 'error')
  });

  return <>
    <Button onClick={() => setOpen(true)} label="" startIcon={<EditIcon />} />
    <Dialog fullWidth maxWidth="md" open={open} onClose={() => setOpen(false)}
      aria-label={translate('settings.model_182_edit_fiscal_year')}>
      <DialogTitle>{translate('settings.model_182_edit_fiscal_year')}</DialogTitle>
      <Model182Form save={handleSubmit}
        initialValues={record}
        render={({ handleSubmitWithRedirect, pristine, saving }) => <>
          <Model182FiscalYearFormContent />
          <DialogActions>
            <Button label="ra.action.cancel" onClick={() => setOpen(false)} disabled={loading}>
              <IconCancel />
            </Button>
            <SaveButton handleSubmitWithRedirect={handleSubmitWithRedirect} pristine={pristine}
              saving={saving} disabled={loading} />
          </DialogActions>
        </>} />
    </Dialog>
  </>;
};

const Model182FiscalYearDeleteButton = ({ record }) => {
  const translate = useTranslate();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirm = () => {
    setLoading(true);
    dataProvider.delete('donations_model_182_fiscal_years', { id: record.id })
      .then(() => {
        setLoading(false);
        setOpen(false);
        refresh();
        notify(translate('settings.done'), 'success');
      })
      .catch(error => {
        setLoading(false);
        notify(error.message, 'error');
      });
  };

  return <>
    <Button label="" onClick={() => setOpen(true)} style={{ color: '#d32f2f' }}>
      <DeleteIcon />
    </Button>
    <Confirm isOpen={open} loading={loading}
      title={translate('settings.model_182_delete_fiscal_year')}
      content={translate('settings.model_182_delete_fiscal_year_confirm')}
      onConfirm={handleConfirm} onClose={() => setOpen(false)} />
  </>;
};

const Model182FiscalYearListValue = ({ label, value, suffix = '%' }) =>
  <Typography variant="body2" component="div" style={{ whiteSpace: 'nowrap' }}>
    <strong>{label}:</strong>{' '}
    {Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 })} {suffix}
  </Typography>;

const Model182FiscalYearsList = props => {
  const translate = useTranslate();
  return <ResourceContextProvider value="donations_model_182_fiscal_years">
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
      <Model182FiscalYearCreateButton />
    </div>
    <RaList {...props} basePath="/donations_model_182_fiscal_years"
      resource="donations_model_182_fiscal_years"
      actions={false} empty={false}
      bulkActionButtons={false} perPage={100} pagination={false}
      sort={{ field: 'year', order: 'DESC' }} title="">
      <Datagrid>
        <NumberField source="year" label={translate('settings.model_182_fiscal_year')} />
        <FunctionField sortable={false} label={translate('settings.model_182_list_nature_1_individual')}
          render={record => <Box>
            <Model182FiscalYearListValue label={translate('settings.model_182_list_first_tranche_limit')}
              value={record.individual_first_tranche_amount} suffix="€" />
            <Model182FiscalYearListValue label={translate('settings.model_182_list_first_tranche')}
              value={record.individual_first_tranche_percentage} />
            <Model182FiscalYearListValue label={translate('settings.model_182_list_standard')}
              value={record.individual_standard_percentage} />
            <Model182FiscalYearListValue label={translate('settings.model_182_list_recurring')}
              value={record.individual_recurring_percentage} />
          </Box>} />
        <FunctionField sortable={false} label={translate('settings.model_182_list_nature_1_legal')}
          render={record => <Box>
            <Model182FiscalYearListValue label={translate('settings.model_182_list_standard')}
              value={record.legal_standard_percentage} />
            <Model182FiscalYearListValue label={translate('settings.model_182_list_recurring')}
              value={record.legal_recurring_percentage} />
          </Box>} />
        <FunctionField sortable={false}
          label={`${translate('settings.model_182_list_nature_2')} · ${translate('settings.model_182_individuals_block')}`}
          render={record => <Model182FiscalYearListValue
            label={translate('settings.model_182_list_standard')}
            value={record.nature_2_individual_percentage} />} />
        <FunctionField sortable={false}
          label={`${translate('settings.model_182_list_nature_2')} · ${translate('settings.model_182_legal_entities_block')}`}
          render={record => <Model182FiscalYearListValue
            label={translate('settings.model_182_list_standard')}
            value={record.nature_2_legal_percentage} />} />
        <FunctionField sortable={false} label={translate('settings.model_182_list_nature_4')}
          render={record => <Model182FiscalYearListValue
            label={translate('settings.model_182_list_key_f')}
            value={record.nature_4_affiliation_percentage} />} />
        <Model182FiscalYearEditButton />
        <Model182FiscalYearDeleteButton />
      </Datagrid>
    </RaList>
  </ResourceContextProvider>;
};

const Model182AutonomousDeductionFormContent = () => {
  const translate = useTranslate();
  const languageChoices = choicesLanguage(translate, true);
  return <DialogContent>
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <NumberInput fullWidth source="year" step={1}
          label={translate('settings.model_182_fiscal_year')}
          validate={[required(), minValue(2000), maxValue(9999)]} />
      </Grid>
      <Grid item xs={12} sm={4}>
        <ReferenceInput fullWidth source="autonomous_community_code"
          reference="donations_model_182_autonomous_communities"
          sort={{ field: 'id', order: 'ASC' }} perPage={100}
          label={translate('settings.model_182_autonomous_community_code')}>
          <SelectInput optionText={choice => `${choice.id} - ${choice.name}`}
            validate={[required()]} />
        </ReferenceInput>
      </Grid>
      <Grid item xs={12} sm={4}>
        <NumberInput fullWidth source="percentage" step={0.01}
          label={translate('settings.model_182_autonomous_percentage')}
          validate={[required(), minValue(0), maxValue(100)]} />
      </Grid>
      {languageChoices.map((language, index) => <Grid item xs={12} sm={6} key={language.id}>
        <TextInput source={`translations.${index}.lang`} defaultValue={language.id}
          style={{ display: 'none' }} label="" />
        <TextInput fullWidth source={`translations.${index}.name`}
          label={`${translate('settings.model_182_autonomous_name')} (${language.name})`}
          validate={language.id === defaultLanguage
            ? [required(), validateMaxLength(150, translate('common.validation.maxLength'))]
            : [validateMaxLength(150, translate('common.validation.maxLength'))]} />
      </Grid>)}
      <Grid item xs={12}>
        <BooleanInput source="active" label={translate('settings.model_182_autonomous_active')} />
      </Grid>
    </Grid>
  </DialogContent>;
};

const model182AutonomousDeductionPayload = values => {
  const active = model182InputValue(values.active);
  return {
    year: Number(model182InputValue(values.year)),
    autonomous_community_code: String(model182InputValue(values.autonomous_community_code)),
    percentage: Number(model182InputValue(values.percentage)),
    active: active === true || active === 'true',
    translations: (values.translations || []).map(translation => ({
      lang: Number(model182InputValue(translation.lang)),
      name: String(model182InputValue(translation.name) || '')
    }))
  };
};

const Model182AutonomousDeductionCreateButton = () => {
  const translate = useTranslate();
  const notify = useNotify();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);
  const [copyFromId, setCopyFromId] = useState(0);
  const [create, { loading }] = useCreate('donations_model_182_autonomous_deductions');
  const deductionsResult = useGetList(
    'donations_model_182_autonomous_deductions',
    { page: 1, perPage: 100 },
    { field: 'id', order: 'DESC' },
    {}
  );
  const deductions = (deductionsResult.ids || [])
    .map(id => deductionsResult.data[id])
    .filter(Boolean)
    .sort((left, right) => Number(right.year) - Number(left.year) || left.id - right.id);
  const copySource = deductions.find(item => item.id === copyFromId);
  const copyChoices = deductions.map(item => ({
    id: item.id,
    name: `${item.year} · ${item.autonomous_community_name} · ${item.name} (${Number(item.percentage).toLocaleString(undefined, { maximumFractionDigits: 2 })} %)`
  }));
  const languageChoices = choicesLanguage(translate, true);
  const initialValues = {
    active: copySource ? copySource.active : true,
    year: copySource ? copySource.year : undefined,
    autonomous_community_code: copySource
      ? copySource.autonomous_community_code : undefined,
    percentage: copySource ? copySource.percentage : undefined,
    translations: languageChoices.map(language => ({
      lang: language.id,
      name: copySource ? ((copySource.translations || []).find(
        item => Number(item.lang) === Number(language.id)) || {}).name || '' : ''
    }))
  };
  const handleClose = () => {
    setOpen(false);
    setCopyFromId(0);
  };
  const handleSubmit = values => create({
    payload: { data: model182AutonomousDeductionPayload(values) }
  }, {
    onSuccess: () => {
      handleClose();
      refresh();
      notify(translate('settings.done'), 'success');
    },
    onFailure: error => notify(error.message, 'error')
  });
  return <>
    <Button onClick={() => setOpen(true)}
      label={translate('settings.model_182_add_autonomous_deduction')}>
      <AddCircleOutlineIcon />
    </Button>
    <Dialog fullWidth maxWidth="md" open={open} onClose={handleClose}
      aria-label={translate('settings.model_182_add_autonomous_deduction')}>
      <DialogTitle>{translate('settings.model_182_add_autonomous_deduction')}</DialogTitle>
      <Model182Form key={`model-182-autonomous-deduction-${copyFromId}`}
        save={handleSubmit} initialValues={initialValues}
        render={({ handleSubmitWithRedirect, pristine, saving }) => <>
          <Model182CopyInput selectedId={copyFromId} choices={copyChoices}
            label={translate('settings.model_182_autonomous_copy_from_question')}
            noneLabel={translate('settings.model_182_autonomous_copy_from_none')}
            onChange={setCopyFromId} />
          <Model182AutonomousDeductionFormContent />
          <DialogActions>
            <Button label="ra.action.cancel" onClick={handleClose} disabled={loading}>
              <IconCancel />
            </Button>
            <SaveButton handleSubmitWithRedirect={handleSubmitWithRedirect} pristine={pristine}
              saving={saving} disabled={loading} />
          </DialogActions>
        </>} />
    </Dialog>
  </>;
};

const Model182AutonomousDeductionEditButton = ({ record }) => {
  const translate = useTranslate();
  const notify = useNotify();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);
  const [update, { loading }] = useUpdate();
  const handleSubmit = values => update({
    type: 'update', resource: 'donations_model_182_autonomous_deductions',
    payload: { id: record.id, data: model182AutonomousDeductionPayload(values) }
  }, {
    onSuccess: () => {
      setOpen(false);
      refresh();
      notify(translate('settings.done'), 'success');
    },
    onFailure: error => notify(error.message, 'error')
  });
  return <>
    <Button onClick={() => setOpen(true)} label="" startIcon={<EditIcon />} />
    <Dialog fullWidth maxWidth="md" open={open} onClose={() => setOpen(false)}
      aria-label={translate('settings.model_182_edit_autonomous_deduction')}>
      <DialogTitle>{translate('settings.model_182_edit_autonomous_deduction')}</DialogTitle>
      <Model182Form save={handleSubmit}
        initialValues={{ ...record,
          translations: choicesLanguage(translate, true).map(language => ({
            lang: language.id,
            name: ((record.translations || []).find(item => item.lang === language.id) || {}).name || ''
          })) }}
        render={({ handleSubmitWithRedirect, pristine, saving }) => <>
          <Model182AutonomousDeductionFormContent />
          <DialogActions>
            <Button label="ra.action.cancel" onClick={() => setOpen(false)} disabled={loading}>
              <IconCancel />
            </Button>
            <SaveButton handleSubmitWithRedirect={handleSubmitWithRedirect} pristine={pristine}
              saving={saving} disabled={loading} />
          </DialogActions>
        </>} />
    </Dialog>
  </>;
};

const Model182AutonomousDeductionDeleteButton = ({ record }) => {
  const translate = useTranslate();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleConfirm = () => {
    setLoading(true);
    dataProvider.delete('donations_model_182_autonomous_deductions', { id: record.id })
      .then(() => {
        setLoading(false);
        setOpen(false);
        refresh();
        notify(translate('settings.done'), 'success');
      })
      .catch(error => {
        setLoading(false);
        notify(error.message, 'error');
      });
  };
  return <>
    <Button label="" onClick={() => setOpen(true)} style={{ color: '#d32f2f' }}>
      <DeleteIcon />
    </Button>
    <Confirm isOpen={open} loading={loading}
      title={translate('settings.model_182_delete_autonomous_deduction')}
      content={translate('settings.model_182_delete_autonomous_deduction_confirm')}
      onConfirm={handleConfirm} onClose={() => setOpen(false)} />
  </>;
};

const Model182AutonomousDeductionsList = props => {
  const translate = useTranslate();
  return <ResourceContextProvider value="donations_model_182_autonomous_deductions">
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
      <Model182AutonomousDeductionCreateButton />
    </div>
    <RaList {...props} basePath="/donations_model_182_autonomous_deductions"
      resource="donations_model_182_autonomous_deductions"
      actions={false} empty={false}
      bulkActionButtons={false} perPage={100} pagination={false}
      sort={{ field: 'id', order: 'DESC' }} title="">
      <Datagrid>
        <NumberField source="year" label={translate('settings.model_182_fiscal_year')} />
        <FunctionField label={translate('settings.model_182_autonomous_community_code')}
          render={record => `${record.autonomous_community_code} - ${record.autonomous_community_name}`} />
        <TextField source="name" label={translate('settings.model_182_autonomous_name')} />
        <NumberField source="percentage"
          label={translate('settings.model_182_autonomous_percentage')} />
        <BooleanField source="active" label={translate('settings.model_182_autonomous_active')} />
        <Model182AutonomousDeductionEditButton />
        <Model182AutonomousDeductionDeleteButton />
      </Datagrid>
    </RaList>
  </ResourceContextProvider>;
};

export const SettingsGeneralConfiguration = () => {
  const translate = useTranslate();
  const dataProvider = useDataProvider();
  const [info, setInfo] = useState();
  const notify = useNotify();
  const [update] = useUpdate();
  const history = useHistory();
  const location = useLocation();
  const activeTab = location.pathname.endsWith('/tax-defaults') ? 'tax-defaults'
    : location.pathname.endsWith('/model-182') ? 'model-182' : 'fees';
  useEffect(() => {
    dataProvider.getOne('utils/general-settings', { id: 0 })
      .then(({ data }) => setInfo(data))
      .catch(error => notify(error.message, 'error'));
  }, [dataProvider, notify]);
  if (!info) return null;

  const handleSubmit = values => {
    const fields = activeTab === 'fees' ? ["ara_tickets_commission","ara_tickets_tax_percent","ara_tickets_minimum_fee","tickets_management_fees_included","ara_subscriptions_commission","ara_subscriptions_tax_percent","ara_subscriptions_minimum_fee","ara_tickets_subscription_fee_per_ticket","subscriptions_management_fees_included","donations_commission","donations_tax_percent"] : ["tickets_vat_percent","tickets_vat_included","subscriptions_vat_percent","subscriptions_vat_included"];
    const data = fields.reduce((result, field) => ({ ...result, [field]: values[field] }), {});
    update({ type: 'update', resource: 'utils/general-settings', payload: { id: 0, data } }, {
      onSuccess: () => { notify(translate('settings.done'), 'success'); history.push('/settings'); },
      onFailure: error => notify(error.message, 'error'),
    });
  };
  return <>
    <br />
    <Typography variant="h5" className="grey8" align="center">{translate('settings.general_configuration')}</Typography>
    <Box sx={{ width: '100%', maxWidth: activeTab === 'model-182' ? 1500 : 850,
      bgcolor: 'background.paper', padding: '25px' }} className="settings_box">
      <Tabs value={activeTab} onChange={(event, value) => history.push('/settings-general/' + value)}>
        <MuiTab value="fees" label={translate('settings.commissions')} />
        <MuiTab value="tax-defaults" label={translate('settings.default_taxes')} />
        <MuiTab value="model-182" label={translate('settings.model_182_fiscality_tab')} />
      </Tabs>
      {activeTab === 'model-182' ? <>
        <Model182FiscalYearsList />
        <Divider sx={{ my: 3 }} />
        <Typography variant="h6" className="grey8">
          {translate('settings.model_182_autonomous_deductions_catalog')}
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          {translate('settings.model_182_autonomous_deductions_catalog_help')}
        </Typography>
        <Model182AutonomousDeductionsList />
      </> :
        <FormWithRedirect key={activeTab} resource="utils/general-settings" save={handleSubmit}
          initialValues={{ id: 0,
            ara_tickets_commission: info.ara_tickets_commission == null ? 1 : info.ara_tickets_commission,
            ara_tickets_tax_percent: info.ara_tickets_tax_percent == null ? 21 : info.ara_tickets_tax_percent,
            ara_tickets_minimum_fee: info.ara_tickets_minimum_fee == null ? 0.5 : info.ara_tickets_minimum_fee,
            tickets_management_fees_included: info.tickets_management_fees_included == null ? false : info.tickets_management_fees_included,
            ara_subscriptions_commission: info.ara_subscriptions_commission == null ? 1 : info.ara_subscriptions_commission,
            ara_subscriptions_tax_percent: info.ara_subscriptions_tax_percent == null ? 21 : info.ara_subscriptions_tax_percent,
            ara_subscriptions_minimum_fee: info.ara_subscriptions_minimum_fee == null ? 0.5 : info.ara_subscriptions_minimum_fee,
            ara_tickets_subscription_fee_per_ticket: info.ara_tickets_subscription_fee_per_ticket == null ? true : info.ara_tickets_subscription_fee_per_ticket,
            subscriptions_management_fees_included: info.subscriptions_management_fees_included == null ? false : info.subscriptions_management_fees_included,
            donations_commission: info.donations_commission == null ? 1 : info.donations_commission,
            donations_tax_percent: info.donations_tax_percent == null ? 21 : info.donations_tax_percent,
            tickets_vat_percent: info.tickets_vat_percent == null ? 10 : info.tickets_vat_percent,
            tickets_vat_included: info.tickets_vat_included == null ? true : info.tickets_vat_included,
            subscriptions_vat_percent: info.subscriptions_vat_percent == null ? 10 : info.subscriptions_vat_percent,
            subscriptions_vat_included: info.subscriptions_vat_included == null ? true : info.subscriptions_vat_included,
          }}
          render={formProps => <Box sx={{ paddingTop: '20px' }}>
            {activeTab === 'fees' ? <>
              <Typography variant="body2">{translate('settings.commissions_help')}</Typography>
              <ServicePricingInputs />
            </> : <DefaultTaxInputs />}
            <SaveButton saving={formProps.saving} handleSubmitWithRedirect={formProps.handleSubmitWithRedirect} />
          </Box>}
        />
      }
    </Box>
  </>;
};

export const SettingsSAdmin = ( props ) => {
    
  var translate = useTranslate();
  const history = useHistory();
  const dataProvider = useDataProvider();
  const [info, setInfo] = useState();
  const notify = useNotify();
        
  const handleBackupClick = (e) => {
    e.preventDefault();
        
    dataProvider.getOne('utils/backup', { id: 0 })
      .then(({ data }) => {    
        notify(translate('settings.done'), 'success');
      })
      .catch(error => {   
        notify(error.message, 'error');
      });        
  };
    
  const handleTemplatesClick = (e) => {
    e.preventDefault();
        
    dataProvider.getOne('templates/copy', { id: 0 })
      .then(({ data }) => {    
        notify(translate('settings.templates_copied'), 'success');
      })
      .catch(error => {   
        notify(error.message, 'error');
      });
        
  };
    
  const handleIbansClick = (e) => {
    e.preventDefault();
        
    dataProvider.getOne('ibans/copy', { id: 0 })
      .then(({ data }) => {    
        notify(translate('settings.done'), 'success');
      })
      .catch(error => {   
        notify(error.message, 'error');
      });
        
  };
  
  const handleRemittancesClick = (e) => {
    e.preventDefault();
        
    dataProvider.getOne('subscriptions/remittances/copy', { id: 0 })
      .then(({ data }) => {    
        notify(translate('settings.done'), 'success');
      })
      .catch(error => {   
        notify(error.message, 'error');
      });
        
  };
  
  const handlePostalLabelsClick = (e) => {
    e.preventDefault();
        
    dataProvider.getOne('postal_labels/default', { id: 0 })
      .then(({ data }) => {    
        notify(translate('settings.done'), 'success');
      })
      .catch(error => {   
        notify(error.message, 'error');
      });
        
  };
  
  const handleTicketsClick = (e) => {
    e.preventDefault();
        
    dataProvider.getOne('utils/tickets', { id: 0 })
      .then(({ data }) => {    
        notify(translate('settings.done'), 'success');
      })
      .catch(error => {   
        notify(error.message, 'error');
      });
        
  };
  
  return (
        
    <>
      <br/>
      <Typography variant="h5" className="grey8" align="center">
        {translate('settings.maintenance')}              
      </Typography>

      <Box sx={{ width: '100%', maxWidth: 500, bgcolor: 'background.paper', padding: '25px' }} className="settings_box" >
        <List>
        
          <ListItem>
            <ListItemButton component="a" href="" onClick={handleBackupClick} >
              <ListItemIcon>
                <BackupIcon />
              </ListItemIcon>
              <ListItemText primary={translate('settings.backup')} secondary={translate('settings.backup_desc')}  />
            </ListItemButton>
          </ListItem>
          
          <ListItem>
            <ListItemButton component="a" href="" onClick={handleTemplatesClick} >
              <ListItemIcon>
                <DraftsIcon />
              </ListItemIcon>
              <ListItemText primary={translate('settings.emails_copy')} secondary={translate('settings.emails_copy_desc')}  />
            </ListItemButton>
          </ListItem>

          <ListItem style={{ display: 'none' }}>
            <ListItemButton component="a" href="" onClick={handleIbansClick} >
              <ListItemIcon>
                <AccountBalanceIcon />
              </ListItemIcon>
              <ListItemText primary={translate('settings.ibans_copy')} secondary={translate('settings.ibans_copy_desc')}  />
            </ListItemButton>
          </ListItem>
          
          <ListItem style={{ display: 'none' }}>
            <ListItemButton component="a" href="" onClick={handleRemittancesClick} >
              <ListItemIcon>
                <DraftsIcon />
              </ListItemIcon>
              <ListItemText primary={translate('settings.remittances_subscriptions')} secondary={translate('settings.remittances_subscriptions_desc')}  />
            </ListItemButton>
          </ListItem>
          
          <ListItem style={{ display: 'none' }}>
            <ListItemButton component="a" href="" onClick={handlePostalLabelsClick} >
              <ListItemIcon>
                <BorderAllIcon />
              </ListItemIcon>
              <ListItemText primary={translate('settings.sa_postal_labels')} secondary={translate('settings.sa_postal_labels_desc')}  />
            </ListItemButton>
          </ListItem>
          
          <ListItem>
            <ListItemButton component="a" href="" onClick={handleTicketsClick} >
              <ListItemIcon>
                <BorderAllIcon />
              </ListItemIcon>
              <ListItemText primary="Accions projecte tickets" secondary=""  />
            </ListItemButton>
          </ListItem>
                
        </List>
            
      </Box>
    </>
    
  );
  
};


export const SettingsDonationsOwn = ( props ) => {
    
  var translate = useTranslate();
  const history = useHistory();
  const dataProvider = useDataProvider();
  const [info, setInfo] = useState();
    
  const [showDialog, setShowDialog] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();  
  const [update, { loading, error }] = useUpdate();
        
  useEffect(() => {
    if (localStorage.getItem('associations_id') > 0)
    {
      dataProvider.getOne('associations', { id: localStorage.getItem('associations_id') })
        .then(({ data }) => {    
          setInfo(data);
        })
        .catch(error => {                                
        });
    }
  }, []);

  if (!info) return null;
    
  const handleSubmit = async values => {
    update(
      { 
        type: 'update', 
        resource: 'associations/donations_own', 
        payload : { id: values.id, data : values }
      },
      {
        onSuccess: ({ data }) => {
          history.push('/settings');
        },
        onFailure: ( error ) => {
          notify(error.message, 'error');
        }
      }
    );
  };    
        
  return (
                        
    <FormWithRedirect
      resource="associations"        
      save={handleSubmit}
      initialValues={{ id : localStorage.getItem('associations_id'), ...info
      }}
      render={formProps => (
            
        <>
          <br/>
          <Typography variant="h5" className="grey8" align="center">
            {translate('settings.donations_own')}              
          </Typography>  
            
          <Box sx={{ width: '100%', maxWidth: 800, bgcolor: 'background.paper', padding: '25px' }} className="settings_box" >
                
            <Grid container spacing={1}>
                  <Grid item xs={12}>   
                    <TextInput fullWidth source="donations_own_header" multiline label={translate('settings.donations_own_donations_own_header')} validate={[]} />
                  </Grid> 
                  <Grid item xs={12}>   
                    <TextInput fullWidth source="donations_own_footer" multiline label={translate('settings.donations_own_donations_own_footer')} validate={[]} />
                  </Grid> 
                  <Grid item xs={12}>   
                    <TextInput fullWidth source="donations_own_privacy" multiline label={translate('settings.donations_own_donations_own_privacy')} validate={[]} />
                  </Grid> 
                  <Grid item xs={12}>   
                    <TextInput fullWidth source="donations_own_terms" multiline label={translate('settings.donations_own_donations_own_terms')} validate={[]} />
                  </Grid> 
                  <Grid item xs={12}>   
                    <TextInput fullWidth source="donations_own_fiscal" multiline label={translate('settings.donations_own_donations_own_fiscal')} validate={[]} />
                  </Grid>                   
            </Grid>    
            <SaveButton
              saving={formProps.saving}
              handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
            />

          </Box>
        </>
            
      )}
    />
    
  );
  
};


export const SettingsDocs = ( props ) => {
    
  var translate = useTranslate();
  const history = useHistory();
  const dataProvider = useDataProvider();
  const [info, setInfo] = useState();
    
  const [showDialog, setShowDialog] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();  
  const [update, { loading, error }] = useUpdate();
            
        
  return (
      <>
      <br/>
      <Typography variant="h5" className="grey8" align="center">
        {translate('settings.docs')}              
      </Typography>
      <Box sx={{ bgcolor: 'background.paper', padding: '20px' }} className="settings_box" >
        <DocsList target={targets.SETTINGS_DOCS} items_id={localStorage.getItem('associations_id')} />
      </Box>
      <br/>
      </>
    
  );
  
};
